// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-04T01:23:19.865Z
// Property: Colonial Square (ID: 6767906449167190)
// Collections: 23 amenities, 4 floorplans (live), 20 photos, 79 POIs, 3 reviews, 2 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "6767906449167190",
  "property_external_id": "978670",
  "property_zillow_url": "https://www.zillow.com/apartments/bellevue-wa/colonial-square/5XjQV5/",
  "property_apartments_url": "https://www.apartments.com/colonial-square-bellevue-wa/x8kdjwn/",
  "property_google_business_url": "https://www.google.com/maps/place/Colonial+Square/data=!4m2!3m1!1s0x0:0xcf4437e3c35f066b?sa=X&ved=2ahUKEwi3ranX84OTAxUpz_ACHUkGM_sQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "47709118887",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "colonial-square",
  "property_name": "Colonial Square",
  "property_website_url": "https://www.colonialsquareapartmenthomes.com",
  "property_domain": "https://www.colonialsquareapartmenthomes.com",
  "property_address": "1616 156th Ave NE",
  "property_full_address": "1616 156th Ave NE, Bellevue, WA 98007",
  "property_address_1": "1616 156th Ave NE",
  "property_address_2": null,
  "property_address_city": "Bellevue",
  "property_address_state": "WA",
  "property_address_zip_full": "98007",
  "property_address_zip": "98007",
  "property_address_country": "US",
  "property_address_county": "King County",
  "property_neighborhood_address": "Crossroads",
  "property_address_latitude": "47.6246971",
  "property_address_longitude": "-122.1302174",
  "property_email": "colonialsquare@weidner.com",
  "property_phone": "4255785811",
  "property_call_tracking_phone": "425-256-4046",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Colonial Square in Bellevue, WA, where contemporary comfort meets vibrant living. Choose from stylish studios and spacious one-bedroom apartments featuring granite countertops and black stainless steel appliances. Enjoy exceptional amenities like a fitness center, indoor pool, and scenic picnic areas. Start your journey to a new home today!",
  "property_long_description": "**Discover Modern Living at Colonial Square in Bellevue, WA**\n\nWelcome to Colonial Square, where comfort meets convenience in the heart of Bellevue! Our vibrant apartment community features stylish floor plans, including spacious studios and inviting one-bedroom apartments to suit your lifestyle. Each home boasts luxurious granite countertops and sleek black and stainless steel appliances, ensuring you have everything you need for enjoyable living.\n\nAt Colonial Square, we pride ourselves on offering a wealth of exceptional amenities. Enjoy the ease of on-site maintenance and management, while our courteous patrol ensures your peace of mind. Unwind in our serene courtyard, or host a barbecue in our picnic area as you soak in the scenic views. For active residents, our fitness center, indoor pool, and sports courts — including volleyball and badminton — provide endless opportunities for fun and fitness.\n\nOur community embraces a smoke-free environment with convenient laundry facilities, ample parking, and a unique mini-golf area, perfect for family and friends to enjoy. Plus, sustainability matters to us; that’s why we offer recycling options for our residents.\n\nLocated in the beautiful Bellevue area, Colonial Square is not just a place to live, but a place to thrive. Whether you're here to kick back by the pond or get moving with your neighbors, we have something for everyone.\n\nDon’t miss out on the opportunity to call Colonial Square your new home. Browse our available apartments today or schedule a tour to experience our community firsthand! Your perfect home awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-0a3b-738f-a6d2-e533b60b2448.webp",
  "property_featured_image_media": {
    "alt_text": "Colonial Square Apartment Homes monument sign with landscaping.",
    "public_id": "01a035f9-0a3b-738f-a6d2-e533b60b2448",
    "storage_key": "property/6767906449167190/01a035f9-0a3b-738f-a6d2-e533b60b2448.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "153",
  "property_year_built": "1969",
  "property_year_renovated": null,
  "property_walk_score": "83",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.42483660130719",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "Varies",
  "property_pet_deposit": "300",
  "property_monthly_pet_rent": "50",
  "property_max_pets": "0",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of 1 dog and 1 cat per unit.",
  "property_pet_policy_description": "Cats and dogs are allowed. Pet fee: $200 one‑time. Pet deposit: $300. Monthly pet rent: $45 per pet. Maximum of 1 dog and 1 cat per unit.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://alaska-weidner.securecafe.com/onlineleasing/colonial-square-3/floorplans.aspx",
  "property_resident_portal_url": "https://alaska-weidner.securecafenet.com/residentservices/colonial-square-3/userlogin",
  "property_apply_now_url": "https://alaska-weidner.securecafe.com/onlineleasing/colonial-square-3/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021e-f79b-75e6-bed5-ecc0a0a6d5bf.webp",
  "property_primary_logo_media": {
    "alt_text": "Colonial Square Apartments logo with an eagle.",
    "public_id": "019d021e-f79b-75e6-bed5-ecc0a0a6d5bf",
    "storage_key": "property/6767906449167190/019d021e-f79b-75e6-bed5-ecc0a0a6d5bf.webp",
    "width": 2376,
    "height": 894
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021e-f79b-75e6-bed5-ecc0a0a6d5bf.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Colonial Square Apartments logo with an eagle.",
    "public_id": "019d021e-f79b-75e6-bed5-ecc0a0a6d5bf",
    "storage_key": "property/6767906449167190/019d021e-f79b-75e6-bed5-ecc0a0a6d5bf.webp",
    "width": 2376,
    "height": 894
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d0221-3612-72bc-90d8-846d03ec9014.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Colonial Square Apartments logo with an eagle and text.",
    "public_id": "019d0221-3612-72bc-90d8-846d03ec9014",
    "storage_key": "property/6767906449167190/019d0221-3612-72bc-90d8-846d03ec9014.webp",
    "width": 640,
    "height": 241
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#592A39",
  "property_secondary_color": "#EDE1CF",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#AB6E62",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 1",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": " - 550",
  "property_sqft_min": "340",
  "property_sqft_max": "550",
  "property_price_range": "1383 - 1955",
  "property_price_min": "1580",
  "property_price_max": "1955",
  "property_available_units": 7,
  "property_facebook_url": "https://www.facebook.com/ColonialSquareApartmentHomes",
  "property_instagram_url": "https://www.instagram.com/weidnerapartmenthomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJX77u_qRtkFQRawZfw-M3RM8",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Colonial Square",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Apartment Home",
  "property_home_amenities_blurb": "Welcome to Colonial Square in Bellevue, WA, where comfort meets lifestyle. Choose from stylish studio and one-bedroom apartments featuring granite countertops and black stainless steel appliances. Enjoy our vibrant community amenities, including a serene pond, indoor pool, fitness center, and picnic area—perfect for relaxation and recreation. Explore your new home today!",
  "property_home_floorplans_blurb": "At Colonial Square in Bellevue, WA, your ideal living space awaits! With a variety of thoughtfully designed floor plans, each apartment is tailored for comfort and style. Embrace a vibrant community and lifestyle that feels like home. Browse our available apartments today and find the perfect fit for you!",
  "property_home_gallery_blurb": "At Colonial Square in Bellevue, WA, life unfolds in inviting studio and one-bedroom apartments equipped with granite countertops and sleek stainless steel appliances. Enjoy a myriad of amenities, from a refreshing indoor pool to serene pond views. Picture yourself living here, surrounded by landscaped courtyards and playful mini-golf!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Bellevue, Colonial Square connects you to vibrant attractions like the Bellevue Arts Museum, serene Bellevue Botanical Garden, and the playful KidsQuest Children's Museum. Enjoy nearby leisure at Marymoor Park and immerse yourself in the charm of community parks. Your adventured lifestyle awaits!",
  "property_home_reviews_blurb": "At Colonial Square in Bellevue, WA, residents rave about our vibrant community atmosphere and modern amenities. One delighted tenant shares, \"Living here feels like a dream, with friendly neighbors and beautiful spaces.\" Experience the charm for yourself—see what our residents have to say about living at our community!",
  "property_neighborhood_blurb": "Welcome to Colonial Square, where vibrant living meets endless exploration in Bellevue! Enjoy lush parks, cultural gems like the Bellevue Arts Museum, and the interactive KidsQuest Children's Museum—all just minutes away. With access to top educational institutions and fitness centers, your urban adventure begins here. Dive into the local scene today!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Colonial Square in Bellevue, WA, life unfolds amidst a blend of comfort and leisure. Select from stylish studio or one-bedroom apartments, each featuring modern finishes like granite countertops and stainless steel appliances. Enjoy amenities such as an indoor pool, fitness center, and serene pond, all while living smoke-free.",
  "property_applynow_blurb": "At Colonial Square in Bellevue, WA, choose from stylish studio or one-bedroom apartments featuring granite countertops and sleek stainless steel appliances. Enjoy resort-style amenities like an indoor pool, fitness center, and mini-golf—all while surrounded by beautiful views and lush courtyards. Find your new home and lease online today!",
  "property_contactus_blurb": "At Colonial Square in Bellevue, WA, we offer stylish studio and one-bedroom floor plans designed for modern living. Each space perfectly balances comfort and functionality. Have questions? Our leasing team is ready to assist you! Reach out today and discover your ideal home at Colonial Square.",
  "property_faqs_blurb": "At Colonial Square in beautiful Bellevue, WA, our diverse floor plans—including cozy studios and spacious one-bedroom options—cater to every lifestyle. Have questions? Our FAQs page holds the answers you seek about community amenities and living here, guiding you toward choosing your perfect home. Engage with us today!",
  "property_floorplans_blurb": "At Colonial Square in Bellevue, WA, we offer thoughtfully designed studio and one-bedroom floor plans to fit your lifestyle. Each home is a canvas for your personal touch. Browse our available apartment homes today and uncover the ideal layout that perfectly aligns with your vision for comfortable living.",
  "property_gallery_blurb": "At Colonial Square in Bellevue, WA, every corner invites you to make memories. Picture yourself enjoying our lush picnic area, indoor pool, and vibrant mini golf. Choose from stylish studio and one-bedroom floor plans featuring granite countertops and modern appliances. Life here blends comfort with fun—your perfect community awaits!",
  "property_interactivemap_blurb": "Welcome to Colonial Square in Bellevue, WA, where comfort meets convenience. Choose from spacious studios or one-bedroom apartments, all featuring stylish granite countertops and modern black stainless steel appliances. Enjoy a range of amenities, from a refreshing indoor pool to a scenic pond, all while exploring our interactive community map to find your perfect home!",
  "property_pets_blurb": "At Colonial Square in Bellevue, WA, your furry friends are more than welcome! With a convenient pet policy that includes a one-time fee and monthly rent, our community embraces pets, ensuring that every family member feels at home. Enjoy spacious living in a vibrant neighborhood tailored for comfort.",
  "property_referafriend_blurb": "At Colonial Square in Bellevue, WA, we believe great friends make great neighbors! With cozy studio and spacious one-bedroom floor plans, our vibrant community welcomes your friends to experience the charm and comfort of home. Refer a friend today and elevate your living experience together in our inviting sanctuary!",
  "property_residentaccess_blurb": "At Colonial Square in Bellevue, WA, we offer a variety of thoughtfully designed floor plans, including cozy studios and spacious one-bedroom apartments. Enhance your living experience—log in to your resident portal for seamless rent payments, maintenance requests, and community updates, all at your fingertips! ",
  "property_reviews_blurb": "At Colonial Square in Bellevue, WA, residents cherish the welcoming atmosphere and spacious layouts of their homes. One satisfied resident raves, \"The sense of community here is unmatched!\" Curious about life in our vibrant neighborhood? See what our residents have to say about living at our community!",
  "property_created_at": "1771538233351",
  "property_scheduletour_blurb": "At Colonial Square in Bellevue, WA, find your perfect retreat with our thoughtfully designed studio and one-bedroom floor plans. Enjoy spacious living in a vibrant community where comfort meets convenience. Schedule a tour today and hear firsthand what our residents love about calling Colonial Square home!",
  "property_thankyou_blurb": "Thank you for reaching out to Colonial Square in beautiful Bellevue, WA! Our diverse floor plans, including cozy studios and spacious one-bedroom apartments, cater to your lifestyle needs. An attentive team member will be in touch soon to help you find your ideal home sweet home.",
  "property_virtualtours_blurb": "Step into Colonial Square, where Bellevue’s charm meets modern living. Choose from our chic studio and spacious one-bedroom apartments, each designed for comfort and style. Experience your future home from anywhere—take a virtual tour today and envision your life in this vibrant community that’s waiting for you!",
  "property_copyright": "2026 All Rights Reserved. Colonial Square",
  "property_seo_title_home": "Colonial Square |  Apartments in Bellevue, WA",
  "property_seo_description_home": "Experience luxury living at Colonial Square in Bellevue, WA. Choose from studios to one-bedrooms, plus fantastic amenities. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Bellevue, WA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Colonial Square in Bellevue, WA! Explore unique floor plans including cozy studios and stylish one-bedroom options today!",
  "property_seo_title_amenities": "Amenities | Bellevue, WA Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at Colonial Square in Bellevue, WA. Enjoy stunning views, modern amenities, and a vibrant community perfect for relaxation and fun!",
  "property_seo_title_gallery": "Gallery | Apartments in Bellevue, WA",
  "property_seo_description_gallery": "Embrace life at Colonial Square in Bellevue, WA! From modern studios to scenic one-bedroom homes, our amenities like a fitness center and serene pond await.",
  "property_seo_title_virtualtours": "Virtual Tours | Colonial Square Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Colonial Square in Bellevue, WA! Experience our inviting studio and one-bedroom layouts with a virtual tour today!",
  "property_seo_title_interactivemap": "Interactive Map | Colonial Square Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at Colonial Square, Bellevue, WA! Enjoy spacious layouts, great amenities, and an interactive map for easy exploration.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Bellevue, WA",
  "property_seo_description_neighborhood": "Immerse yourself in Bellevue’s charm at Colonial Square! Uncover local favorites and vibrant attractions just steps from our studio and one-bedroom apartments.",
  "property_seo_title_contact": "Contact Us | Colonial Square",
  "property_seo_description_contact": "Connect with Colonial Square in Bellevue, WA. Whether you seek a studio or one-bedroom, our leasing team is ready to help you find your perfect home!",
  "property_seo_title_faqs": "FAQs | Apartments in Bellevue, WA",
  "property_seo_description_faqs": "Uncover answers to your questions about Colonial Square in Bellevue, WA. Dive into our FAQs to learn more about our vibrant community and amenities!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Bellevue, WA",
  "property_seo_description_reviews": "Read real stories from our Colonial Square residents in Bellevue, WA, and see why our community’s amenities and welcoming vibe make it a perfect home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Bellevue, WA",
  "property_seo_description_applynow": "Experience the charm of Colonial Square in Bellevue, WA. From modern floor plans to lush amenities, find your perfect home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Colonial Square",
  "property_seo_description_residentaccess": "Log in to Colonial Square's resident portal for easy rent payments, maintenance requests, and community updates in beautiful Bellevue, WA. Your comfort awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Colonial Square",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Colonial Square in Bellevue, WA, and enjoy rewards while building a vibrant community together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Colonial Square",
  "property_seo_description_scheduletour": "Experience Bellevue living at Colonial Square! Schedule a tour today to see our vibrant community, stylish amenities, and welcoming atmosphere waiting for you.",
  "property_seo_title_privacy": "Privacy Policy | Colonial Square",
  "property_seo_description_privacy": "At Colonial Square in Bellevue, WA, your privacy matters. Dive into our policies and see how we protect your personal information. View our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Colonial Square",
  "property_seo_description_accessibility": "At Colonial Square in Bellevue, WA, we prioritize accessibility for all. Join us in fostering digital inclusion and ensuring everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Colonial Square",
  "property_seo_description_sitemap": "Uncover every corner of Colonial Square in Bellevue, WA! Navigate our sitemap for a seamless experience in finding your perfect home today.",
  "property_seo_title_thankyou": "Thank You | Colonial Square",
  "property_seo_description_thankyou": "Thank you for reaching out to Colonial Square in Bellevue, WA! Our team will connect soon to help you find your perfect apartment home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Bellevue, WA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793654764153",
  "amenities": [
    {
      "id": "ec_30b1cd24df3ddd0f935e05fc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769377",
      "title": "On-site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ab3d906064db285a2af0a550",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769378",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de1cad53e415f8d95d9f5eb0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769380",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b23a1be6663161c810f0511",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769381",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_432ac07583f0ef266a7e04de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769384",
      "title": "Laundry Facilities/Laundry Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59e8e8df3c996f9d5d36467b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769385",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dde943aeb847bf0e21139ab9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769386",
      "title": "Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_09b891467c1785b1b0c07aa8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769391",
      "title": "Mini Golf",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6ebbea137b83423afb4b0fbe",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769392",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-c92b-741a-b3f9-2ee0f2566624.webp",
      "amenity_image_media": {
        "alt_text": "Fitness center with cardio equipment including treadmills, ellipticals, and stationary bikes.",
        "public_id": "01a035f9-c92b-741a-b3f9-2ee0f2566624",
        "storage_key": "property/6767906449167190/01a035f9-c92b-741a-b3f9-2ee0f2566624.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Colonial Square Gym",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e50aa35dbf0aa2a9acfd1e57",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769394",
      "title": "Indoor Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d9a35-9744-74ed-be9f-0139fc4efc0a.webp",
      "amenity_image_media": {
        "alt_text": "Indoor swimming pool with lounge chairs and outdoor views",
        "public_id": "019d9a35-9744-74ed-be9f-0139fc4efc0a",
        "storage_key": "property/6767906449167190/019d9a35-9744-74ed-be9f-0139fc4efc0a.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Colonial Square Indoor Pool",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dde76d489d52ccdebddd9f2c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769395",
      "title": "Volleyball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_05877eab497e16368bfc1419",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769399",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44c683fe1d8df35a99f921cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769402",
      "title": "Electric",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_741acf939ea47582ef6495df",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769403",
      "title": "Multiple Window/Wall units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07505d2b2f65a0b666a60768",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769405",
      "title": "Views",
      "amount": "false",
      "description": "All living room windows have view of Courtyards. Second and third floor specifically have great overlooking views.",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9eaceee5a3b23faaef862a05",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769400",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_edeb9d13037ab5ff9415afdd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769404",
      "title": "Baseboard Heat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_92c9bd7152b6263b2d5a7aa3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "122092916",
      "title": "Black, Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94d9ac0536bf397db9184d41",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769387",
      "title": "Barbecue/Grill Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e07005f0c0cfed4bbbbbf8f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "86769390",
      "title": "Pond",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021e-beb0-7309-b60c-c9e8923eea83.webp",
      "amenity_image_media": {
        "alt_text": "Large circular fountain with a brick border and a water jet in the center, surrounded by manicured bushes and apartment buildings in the background.",
        "public_id": "019d021e-beb0-7309-b60c-c9e8923eea83",
        "storage_key": "property/6767906449167190/019d021e-beb0-7309-b60c-c9e8923eea83.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "Colonial Square Exterior",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a16684709fbbfbfaf2ca0992",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "124799632",
      "title": "Smoke Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8cd7e46e84fb1a7ed9f8ea40",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "87748463",
      "title": "Badminton Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77210521f916f1b81795df83",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "87748464",
      "title": "Ample Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_a3e99f7e984f1252e107d0b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-0a3b-738f-a6d2-e533b60b2448.webp",
      "image_media": {
        "alt_text": "Colonial Square Apartment Homes monument sign with landscaping.",
        "public_id": "01a035f9-0a3b-738f-a6d2-e533b60b2448",
        "storage_key": "property/6767906449167190/01a035f9-0a3b-738f-a6d2-e533b60b2448.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Colonial Square Apartment Homes, featuring a prominent monument sign at the entrance, surrounded by vibrant landscaping.",
      "link": "false",
      "alt_text": "A welcoming monument sign here at Colonial Square displaying the community name set into a red brick base with colorful landscaping, positioned beside a covered building entry featuring brick exterior walls, white columns, gray siding accents, and a paved walkway leading toward the apartment homes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(51).jpg"
    },
    {
      "id": "ec_dca527fb411430b542c8741d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-26aa-71a5-ba84-89e1c3e2ddec.webp",
      "image_media": {
        "alt_text": "Pathway leading to a fountain in a courtyard with manicured hedges and trees.",
        "public_id": "01a035f9-26aa-71a5-ba84-89e1c3e2ddec",
        "storage_key": "property/6767906449167190/01a035f9-26aa-71a5-ba84-89e1c3e2ddec.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the beautifully landscaped courtyard with a refreshing fountain, perfect for relaxation and outdoor enjoyment.",
      "link": "false",
      "alt_text": "A landscaped courtyard here at Colonial Square featuring a central circular fountain with a tall water feature, surrounded by neatly trimmed hedges, colorful seasonal trees, and garden beds, with a straight concrete walkway leading toward the fountain and two-story apartment buildings with exterior walkways framing the peaceful, park-like setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(62).jpg"
    },
    {
      "id": "ec_3536dfb869afd37a7117e123",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-2369-74e8-8f98-42eaf600419b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with fountain and apartment buildings in the background.",
        "public_id": "01a035f9-2369-74e8-8f98-42eaf600419b",
        "storage_key": "property/6767906449167190/01a035f9-2369-74e8-8f98-42eaf600419b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, featuring a beautiful fountain and surrounded by lush landscaping and apartment buildings.",
      "link": "false",
      "alt_text": "A serene fountain courtyard here at Colonial Square showcasing a large circular pool with a tall central water feature, surrounded by mature evergreen and deciduous trees, manicured hedges, and open green lawn areas, with two-story apartment buildings and exterior walkways framing the peaceful, park-like community setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(64).jpg"
    },
    {
      "id": "ec_542dd14e4e43595a0ff83858",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-23bb-76a7-8602-3c6ee3263526.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with a central green lawn area and benches.",
        "public_id": "01a035f9-23bb-76a7-8602-3c6ee3263526",
        "storage_key": "property/6767906449167190/01a035f9-23bb-76a7-8602-3c6ee3263526.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy the beautifully landscaped grounds, featuring a central green lawn perfect for relaxation, surrounded by lush greenery and comfortable seating areas.",
      "link": "false",
      "alt_text": "A landscaped courtyard lawn here at Colonial Square featuring a large circular green space bordered by gravel pathways and simple bench seating, surrounded by mature trees with seasonal foliage, neatly trimmed shrubs, and two-story apartment buildings with exterior walkways, creating a calm, park-like community gathering area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(54).jpg"
    },
    {
      "id": "ec_453c9ad0fd8f0fae4ee79616",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-2326-707f-9fd9-a51b18485fae.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a pergola and fireplace, surrounded by trees in autumn colors.",
        "public_id": "01a035f9-2326-707f-9fd9-a51b18485fae",
        "storage_key": "property/6767906449167190/01a035f9-2326-707f-9fd9-a51b18485fae.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy the crisp autumn air in our communal outdoor seating area, featuring a cozy fireplace and comfortable seating, perfect for relaxing or socializing.",
      "link": "false",
      "alt_text": "A landscaped outdoor courtyard here at Colonial Square featuring a brick pergola with a built-in grill, a small round table with chairs, and a paved seating area surrounded by manicured shrubs, gravel pathways, and vibrant red and yellow autumn trees, with two-story apartment buildings and exterior walkways in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(59).JPG"
    },
    {
      "id": "ec_1906399ec5318febf9688881",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-2270-77d1-aa14-5599122293f8.webp",
      "image_media": {
        "alt_text": "Volleyball court with net and surrounding trees in autumn colors with apartment buildings in the background.",
        "public_id": "01a035f9-2270-77d1-aa14-5599122293f8",
        "storage_key": "property/6767906449167190/01a035f9-2270-77d1-aa14-5599122293f8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy recreational activities like volleyball amidst the vibrant autumn foliage. Our community offers amenities for an active lifestyle.",
      "link": "false",
      "alt_text": "A landscaped outdoor volleyball court here at Colonial Square featuring a smooth paved playing surface with a central net, surrounded by green lawn, trimmed shrubs, and mature trees with vibrant autumn foliage, while nearby apartment buildings, walking paths, and seating areas create a park-like setting for recreation and relaxation.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(53).jpg"
    },
    {
      "id": "ec_223f982e20b54ce7133f2282",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-3126-72cd-af05-9345c50743bc.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with pergola and fireplace",
        "public_id": "01a035f9-3126-72cd-af05-9345c50743bc",
        "storage_key": "property/6767906449167190/01a035f9-3126-72cd-af05-9345c50743bc.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy relaxing outdoors in the communal seating area, complete with a pergola and fireplace. Perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "A landscaped outdoor gathering area here at Colonial Square featuring a brick pergola with a built-in grill, a small table with chairs beneath the covered structure, and a paved courtyard surrounded by mature evergreen trees, colorful seasonal foliage, manicured shrubs, and two-story apartment buildings with exterior walkways.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(69).JPG"
    },
    {
      "id": "ec_2213041d096be2497cfdacd9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-339f-762d-869e-9c1f80179aef.webp",
      "image_media": {
        "alt_text": "Multifamily property with a volleyball court and lush green landscaping.",
        "public_id": "01a035f9-339f-762d-869e-9c1f80179aef",
        "storage_key": "property/6767906449167190/01a035f9-339f-762d-869e-9c1f80179aef.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at our multifamily property, featuring a volleyball court and beautifully maintained grounds.",
      "link": "false",
      "alt_text": "A landscaped outdoor volleyball court here at Colonial Square featuring a smooth paved playing surface with a central net, bordered by lush green lawn, manicured shrubs, and mature trees with vivid autumn foliage, while surrounding apartment buildings with balconies and walkways create a welcoming, park-like community setting.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(58).JPG"
    },
    {
      "id": "ec_141e65853d73981ed6abcac9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-3478-760d-b0a2-9d0eaa11c580.webp",
      "image_media": {
        "alt_text": "Exterior view of a multi-story apartment building with brick facade and balconies.",
        "public_id": "01a035f9-3478-760d-b0a2-9d0eaa11c580",
        "storage_key": "property/6767906449167190/01a035f9-3478-760d-b0a2-9d0eaa11c580.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Charming exterior of the apartment building featuring brick accents, private balconies, and well-maintained grounds with lush green lawns and mature trees.",
      "link": "false",
      "alt_text": "A tree-lined exterior courtyard here at Colonial Square featuring two-story brick apartment buildings with white railings and exterior walkways, ground-level entry doors and windows, and a well-maintained green lawn bordered by shrubs and mature trees with early autumn foliage under a bright blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(60).JPG"
    },
    {
      "id": "ec_1abef6a1ad32c7500abd5257",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-3537-7221-b285-ca376acc7a2a.webp",
      "image_media": {
        "alt_text": "Indoor swimming pool with lounge chairs and large windows overlooking trees.",
        "public_id": "01a035f9-3537-7221-b285-ca376acc7a2a",
        "storage_key": "property/6767906449167190/01a035f9-3537-7221-b285-ca376acc7a2a.webp",
        "width": 1024,
        "height": 682
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our indoor pool, surrounded by comfortable lounge chairs and bathed in natural light from expansive windows. A perfect amenity for relaxation and recreation.",
      "link": "false",
      "alt_text": "A spacious indoor swimming pool here at Colonial Square featuring a long rectangular pool with stainless steel handrails, a wide pool deck with lounge chairs arranged along floor-to-ceiling windows, smooth light-toned flooring, recessed ceiling lighting, and views of landscaped greenery outside that create a calm and inviting atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(50).JPG"
    },
    {
      "id": "ec_27a9cdfa92c782c21c150647",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-376a-701d-85bc-4bb73fa72279.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines and exercise ball",
        "public_id": "01a035f9-376a-701d-85bc-4bb73fa72279",
        "storage_key": "property/6767906449167190/01a035f9-376a-701d-85bc-4bb73fa72279.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring treadmills, stationary bikes, and more.",
      "link": "false",
      "alt_text": "A compact fitness room here at Colonial Square featuring cardio equipment including a treadmill, stationary bike, and elliptical machine, complemented by a wall mirror, mounted television, large window with blinds bringing in natural light, and neutral carpeting that creates a clean and functional workout space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(56).JPG"
    },
    {
      "id": "ec_e51e1b020efcdb6664d29d35",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-3f63-773a-bccf-b56ca85b7ba9.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, yellow and grey accents, and a window.",
        "public_id": "01a035f9-3f63-773a-bccf-b56ca85b7ba9",
        "storage_key": "property/6767906449167190/01a035f9-3f63-773a-bccf-b56ca85b7ba9.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a queen-size bed with cheerful yellow and grey accents, bedside lamps, and natural light from the window.",
      "link": "false",
      "alt_text": "A cozy bedroom here at Colonial Square featuring a neatly made bed with a patterned yellow and white comforter, layered accent pillows, and a padded headboard, flanked by matching nightstands with modern lamps, complemented by framed wall art, soft carpeted flooring, and a window with vertical blinds providing natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(63).jpg"
    },
    {
      "id": "ec_e8f286dd2e8b34b9bdb129a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-3ead-7775-a575-225753c64240.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, yellow and gray pillows, and a white robe in the closet.",
        "public_id": "01a035f9-3ead-7775-a575-225753c64240",
        "storage_key": "property/6767906449167190/01a035f9-3ead-7775-a575-225753c64240.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush queen-size bed with accent pillows and ample closet space.",
      "link": "false",
      "alt_text": "A welcoming bedroom here at Colonial Square featuring a neatly made bed with a patterned yellow and white comforter, layered accent pillows, and a textured upholstered headboard, accompanied by a nightstand with a table lamp, framed wall art above the bed, soft carpeted flooring, and an open closet with shelving and hanging space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(67).JPG"
    },
    {
      "id": "ec_8a353f59b5c5fe641e1a635d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-405d-7649-9aec-b6115ab2e9e5.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, coffee table, and artwork, leading to a kitchen and bedroom.",
        "public_id": "01a035f9-405d-7649-9aec-b6115ab2e9e5",
        "storage_key": "property/6767906449167190/01a035f9-405d-7649-9aec-b6115ab2e9e5.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stunning living area with plush carpeting, a stylish sofa, and contemporary decor. Enjoy a modern kitchen and a comfortable bedroom, all within your apartment.",
      "link": "false",
      "alt_text": "A cozy open living area here at Colonial Square showcasing a comfortable gray sofa with yellow accent pillows, a modern coffee table with decorative accents, and warm carpeting, flowing into a compact kitchen with wood cabinetry, dark countertops, a breakfast bar with seating, and a view toward a bedroom and vanity area that creates a connected, inviting layout.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(57).JPG"
    },
    {
      "id": "ec_19731ea1f51f578a4c4bbd9d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-4271-706d-8ab2-324481564a4f.webp",
      "image_media": {
        "alt_text": "Bathroom with toilet, sink, granite countertop, and shower curtain.",
        "public_id": "01a035f9-4271-706d-8ab2-324481564a4f",
        "storage_key": "property/6767906449167190/01a035f9-4271-706d-8ab2-324481564a4f.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "A clean and well-maintained bathroom featuring a toilet, sink, and granite countertops, complete with decorative floral accents and plush towels.",
      "link": "false",
      "alt_text": "A clean bathroom here at Colonial Square featuring a granite-style vanity countertop with an integrated sink, wood-tone cabinetry, a large wall mirror, neatly folded towels on a towel bar, a shower curtain with a subtle pattern, and a compact layout that feels functional and well lit.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(55).JPG"
    },
    {
      "id": "ec_c48bcddefbef6e4492d3f9a8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-417d-770d-b093-2a3178ed4375.webp",
      "image_media": {
        "alt_text": "Comfortable seating area with a view of the indoor pool.",
        "public_id": "01a035f9-417d-770d-b093-2a3178ed4375",
        "storage_key": "property/6767906449167190/01a035f9-417d-770d-b093-2a3178ed4375.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting seating area, complete with a beautiful view of the indoor swimming pool. Perfect for a quiet moment or casual conversation.",
      "link": "false",
      "alt_text": "A welcoming lounge area here at Colonial Square featuring four cushioned armchairs with wood frames arranged around a round table, neutral carpeted flooring, framed artwork on warm-toned walls, and a small shelving unit, with large interior and exterior windows that add natural light and create a comfortable space for conversation and relaxation.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(52).JPG"
    },
    {
      "id": "ec_b2cf15241921d1b08b32c1d5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-4bcf-742c-b03e-7c54c52cf60d.webp",
      "image_media": {
        "alt_text": "Stylish living room with gray sofa, yellow accent pillows, and a white coffee table.",
        "public_id": "01a035f9-4bcf-742c-b03e-7c54c52cf60d",
        "storage_key": "property/6767906449167190/01a035f9-4bcf-742c-b03e-7c54c52cf60d.webp",
        "width": 1024,
        "height": 680
      },
      "title": "Apartment",
      "description": "Relax and unwind in this beautifully appointed living space, featuring comfortable seating and modern decor.",
      "link": "false",
      "alt_text": "A cozy living room here at Colonial Square featuring a light gray sofa with yellow accent pillows, a white coffee table with decorative accents, soft carpeted flooring, and modern side tables with lamps, complemented by abstract wall art, a floor lamp, and a large window with vertical blinds that brings in natural light.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(65).JPG"
    },
    {
      "id": "ec_4bfbaadc956850c24e73ef15",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-4c42-70c3-bf13-7485ae432674.webp",
      "image_media": {
        "alt_text": "Living room with gray sofa, yellow pillows, coffee table, and abstract art.",
        "public_id": "01a035f9-4c42-70c3-bf13-7485ae432674",
        "storage_key": "property/6767906449167190/01a035f9-4c42-70c3-bf13-7485ae432674.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable gray sofa, accent pillows, and modern decor, perfect for relaxation and entertaining.",
      "link": "false",
      "alt_text": "A cozy living room here at Colonial Square featuring a soft gray sofa with yellow and patterned accent pillows, a sleek white coffee table with decorative vases, and a side table with a modern lamp, complemented by abstract wall art, neutral carpeting, and warm ambient lighting that creates an inviting and comfortable atmosphere.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(68).JPG"
    },
    {
      "id": "ec_bd4374513179726e31d6a75a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-4bf6-72da-92a6-880f7c008208.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator and stove in an apartment kitchen.",
        "public_id": "01a035f9-4bf6-72da-92a6-880f7c008208",
        "storage_key": "property/6767906449167190/01a035f9-4bf6-72da-92a6-880f7c008208.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Modern apartment kitchen featuring stainless steel appliances, including a refrigerator, microwave, and stove with a kettle. Ample cabinet space and granite countertops complete the look.",
      "link": "false",
      "alt_text": "A compact kitchen here at Colonial Square featuring warm wood cabinetry, speckled countertops, a stainless refrigerator, a built-in microwave above a smooth cooktop range, and a sink set into the counter, with simple decor and neatly arranged cookware creating a functional, efficient space for everyday cooking and meal prep.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(66).JPG"
    },
    {
      "id": "ec_bc0fbc9adb41a4ae45df5611",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a035f9-4f1a-766c-999e-c34b8c20d468.webp",
      "image_media": {
        "alt_text": "Kitchen and dining area with wood cabinets, granite countertops, and a breakfast bar.",
        "public_id": "01a035f9-4f1a-766c-999e-c34b8c20d468",
        "storage_key": "property/6767906449167190/01a035f9-4f1a-766c-999e-c34b8c20d468.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Apartment",
      "description": "Enjoy a functional and stylish kitchen featuring ample cabinet space, granite countertops, and a convenient breakfast bar perfect for casual dining.",
      "link": "false",
      "alt_text": "A compact kitchen here at Colonial Square featuring warm wood cabinetry, dark countertops with bar seating, and a small breakfast bar set with plates and glassware, complemented by wood-style flooring, a stainless-look refrigerator, a nearby sink area with additional cabinets, and soft overhead lighting that creates a functional and welcoming cooking space.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/WA_Colonial_Square_Favorites%20(61).JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6f115bfb-3ee5-409c-9e2f-49cec03998db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Ruchi Indian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1360 156th Ave NE, Bellevue, WA 98007, USA",
      "poi_short_description": "Relaxed place for Indian mainstays such as biryani, tandoori dishes, naan & curry.",
      "poi_long_description": "Relaxed place for Indian mainstays such as biryani, tandoori dishes, naan & curry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-a73e-74c9-9c06-abe553601c6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-a73e-74c9-9c06-abe553601c6c",
        "storage_key": "property/6767906449167190/01a14137-a73e-74c9-9c06-abe553601c6c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ruchiindianrestaurant.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=2457802231964838705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ruchi-indian-restaurant",
      "poi_latitude": "47.6223289",
      "poi_longitude": "-122.1320022",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-625-4491",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSggTKVtkFQRMSttpBveGyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_4d601f17-a65b-4eca-ba46-54f1ce70394d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Tutta Bella Neapolitan Pizzeria - Bellevue",
      "poi_type": "Restaurants",
      "poi_address": "15600 NE 8th St Ste J1, Bellevue, WA 98008, USA",
      "poi_short_description": "Crispy Neapolitan pies served in a lofty space with casual industrial-chic decor.",
      "poi_long_description": "Crispy Neapolitan pies served in a lofty space with casual industrial-chic decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-a99f-70d8-b497-0d0bc9490bd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-a99f-70d8-b497-0d0bc9490bd6",
        "storage_key": "property/6767906449167190/01a14137-a99f-70d8-b497-0d0bc9490bd6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://tuttabella.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11478364469935860424&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tutta-bella-neapolitan-pizzeria---bellevue",
      "poi_latitude": "47.6191788",
      "poi_longitude": "-122.1309891",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-502-7402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34awiLBtkFQRyOr9oKtXS58",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_75a70077-f3bd-43f8-bfff-a1e118054d03",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "JINYA Ramen Bar - Bellevue",
      "poi_type": "Restaurants",
      "poi_address": "15600 NE 8th St Suite 0-11, Bellevue, WA 98008, USA",
      "poi_short_description": "Contemporary Japanese restaurant serving a variety of slow-cooked ramen and vegetarian options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-a54b-71e4-bd9e-8601ade62ce9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-a54b-71e4-bd9e-8601ade62ce9",
        "storage_key": "property/6767906449167190/01a14137-a54b-71e4-bd9e-8601ade62ce9.webp",
        "width": 1024,
        "height": 1280
      },
      "poi_business_url": "https://www.jinyaramenbar.com/locations/bellevue/?utm_medium=soci&utm_source=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13798789189995131856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jinya-ramen-bar---bellevue",
      "poi_latitude": "47.6207918",
      "poi_longitude": "-122.1304133",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-590-9548",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN6THkLptkFQR0PMowKglf78",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_db4187fe-2593-4318-b0e5-11f3011a41a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "The French Bakery @Crossroads Bellevue",
      "poi_type": "Restaurants",
      "poi_address": "15600 NE 8th St K-4, Bellevue, WA 98008, USA",
      "poi_short_description": "Bakery known for croissants & other French pastries & breads, in a cafe serving sandwiches & salads.",
      "poi_long_description": "Bakery known for croissants & other French pastries & breads, in a cafe serving sandwiches & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-a187-76d7-afd7-b7cf3c717f65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-a187-76d7-afd7-b7cf3c717f65",
        "storage_key": "property/6767906449167190/01a14137-a187-76d7-afd7-b7cf3c717f65.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "http://www.thefrenchbakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13366080174262676538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-french-bakery-crossroads-bellevue",
      "poi_latitude": "47.6195375",
      "poi_longitude": "-122.13112359999998",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-747-0557",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_B3r7ptkFQROmxRGhrbfbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_16c172f6-d774-4d8b-a99c-d150e1438738",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Crossroads Grill & Burgers",
      "poi_type": "Restaurants",
      "poi_address": "15600 NE 8th St PM16 Suite PM16 inside the food court, Bellevue, WA 98008, USA",
      "poi_short_description": "Fast-food venue serving American burgers and crispy fries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-1d56-777d-b525-edd0299e8765.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-1d56-777d-b525-edd0299e8765",
        "storage_key": "property/6767906449167190/019d021f-1d56-777d-b525-edd0299e8765.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://crossroadsburger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17298105285573700735&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-grill--burgers",
      "poi_latitude": "47.6190274",
      "poi_longitude": "-122.1306938",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-531-7914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJqVVN_bVtkFQRf2ztoRs3D_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_5cf15b21-9e23-4f11-9930-3f8f59b1ea64",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "1328 156th Ave NE, Bellevue, WA 98007, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-a6e8-70b9-915a-1825ced24ee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-a6e8-70b9-915a-1825ced24ee5",
        "storage_key": "property/6767906449167190/01a14137-a6e8-70b9-915a-1825ced24ee5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.chipotle.com/wa/bellevue/1328-156th-ave-ne?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=1364",
      "poi_directions_map_url": "https://maps.google.com/?cid=10554043936474526312&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "47.6216166",
      "poi_longitude": "-122.1318789",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-214-0011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8-2rhrptkFQRaPJt4Qp_d5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_e79c3b55-e51e-4979-b6f5-bab686dd8943",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Off The Rails Sports Pub",
      "poi_type": "Restaurants",
      "poi_address": "1428 156th Ave NE, Bellevue, WA 98007, USA",
      "poi_short_description": "Neighborhood sports bar featuring numerous pool tables and casual pub fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-a3bb-7780-9f52-f4eafe75c368.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-a3bb-7780-9f52-f4eafe75c368",
        "storage_key": "property/6767906449167190/01a14137-a3bb-7780-9f52-f4eafe75c368.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6088238591780500244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "off-the-rails-sports-pub",
      "poi_latitude": "47.622940799999995",
      "poi_longitude": "-122.1316628",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-326-1314",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14138-34c0-7293-8cff-93496f433f92.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-34c0-7293-8cff-93496f433f92",
        "storage_key": "property/6767906449167190/01a14138-34c0-7293-8cff-93496f433f92.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_jwO6VtkFQRFLPmCr7EfVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_bar"
    },
    {
      "id": "custom_d3d63cca-45dd-4699-8fa9-f889a1554509",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Sushi Me",
      "poi_type": "Restaurants",
      "poi_address": "1299 156th Ave NE Ste 145, Bellevue, WA 98007, USA",
      "poi_short_description": "Casual eatery where raw & cooked Japanese eats served on a conveyor belt pair with beer & sake.",
      "poi_long_description": "Casual eatery where raw & cooked Japanese eats served on a conveyor belt pair with beer & sake.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-a1eb-77f5-9ab2-d6f32d27f602.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-a1eb-77f5-9ab2-d6f32d27f602",
        "storage_key": "property/6767906449167190/01a14137-a1eb-77f5-9ab2-d6f32d27f602.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clover.com/online-ordering/sushi-me-bellevue-2",
      "poi_directions_map_url": "https://maps.google.com/?cid=5423100495010180631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sushi-me",
      "poi_latitude": "47.6214016",
      "poi_longitude": "-122.1327924",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-644-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8cpqLptkFQRF65T2iq5Qks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_7b73257d-f05d-47e1-afc2-dce5a0c03c91",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Happy Lamb Hot Pot, Bellevue",
      "poi_type": "Restaurants",
      "poi_address": "1411 156th Ave NE Ste A, Bellevue, WA 98007, USA",
      "poi_short_description": "At this Mongolian chain eatery, diners cook meat & vegetables in broth at the table.",
      "poi_long_description": "At this Mongolian chain eatery, diners cook meat & vegetables in broth at the table.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-ad03-713a-ab8b-d207ff7890d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-ad03-713a-ab8b-d207ff7890d5",
        "storage_key": "property/6767906449167190/01a14137-ad03-713a-ab8b-d207ff7890d5.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://order.mealkeyway.com/merchant/4b4e394b37417861664f6c485447666d7850493639773d3d/main",
      "poi_directions_map_url": "https://maps.google.com/?cid=5036482397471885023&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "happy-lamb-hot-pot-bellevue",
      "poi_latitude": "47.6231225",
      "poi_longitude": "-122.1332569",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 425-675-1616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpc0kaKVtkFQR38bRWg4u5UU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hot_pot_restaurant"
    },
    {
      "id": "custom_3932c764-0d13-4676-bbf5-4a8a1f1f90eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Ivar's Seafood Bar",
      "poi_type": "Restaurants",
      "poi_address": "1505 156th Ave NE, Bellevue, WA 98007, USA",
      "poi_short_description": "Local chain dishing up fried fish & chowders in casual quarters with nautical accents.",
      "poi_long_description": "Local chain dishing up fried fish & chowders in casual quarters with nautical accents.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-3711-76a7-9074-7efe69916cf7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-3711-76a7-9074-7efe69916cf7",
        "storage_key": "property/6767906449167190/019d021f-3711-76a7-9074-7efe69916cf7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.ivars.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1781194607430140259&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ivars-seafood-bar",
      "poi_latitude": "47.6234478",
      "poi_longitude": "-122.1328127",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 425-747-6433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wHqFKVtkFQRYwG36w4TuBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_8270a4fb-b0df-4952-9f0c-3b79a7c5842a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Mix Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "15600 NE 8th St Ste pm41, Bellevue, WA 98008, USA",
      "poi_short_description": "Casual Japanese eatery serving fresh sushi and seared salmon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-af6f-734e-8046-ebcf9c5bc9b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-af6f-734e-8046-ebcf9c5bc9b5",
        "storage_key": "property/6767906449167190/01a14137-af6f-734e-8046-ebcf9c5bc9b5.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.ordertogo.com/restaurants/mixsushibar/mesh",
      "poi_directions_map_url": "https://maps.google.com/?cid=10849236359411691521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mix-sushi-bar",
      "poi_latitude": "47.619459",
      "poi_longitude": "-122.13085599999998",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-590-9284",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF486AABtkFQRAXD8tvw6kJY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_79b7434a-13bf-4bf3-bd4b-bf689cfa7605",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Nan Hot Pot",
      "poi_type": "Restaurants",
      "poi_address": "15600 NE 8th St Ste O18, Bellevue, WA 98008, USA",
      "poi_short_description": "Authentic Chongqing-style hot pot restaurant featuring specialty ingredients and signature shaved ice desserts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-ae96-7366-89e6-05914ef3e7c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-ae96-7366-89e6-05914ef3e7c8",
        "storage_key": "property/6767906449167190/01a14137-ae96-7366-89e6-05914ef3e7c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.nanhotpotseattle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4392043021295904507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nan-hot-pot",
      "poi_latitude": "47.6208058",
      "poi_longitude": "-122.1297756",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 206-209-1999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJi_1LqIRtkFQR-2aTmtur8zw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hot_pot_restaurant"
    },
    {
      "id": "custom_88a916b8-a1de-48cc-aa72-228458b96ca8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Dough Zone Dumpling House Overlake",
      "poi_type": "Restaurants",
      "poi_address": "14625 NE 24th St #4b, Bellevue, WA 98007, USA",
      "poi_short_description": "Modern Chinese eatery serving signature soup dumplings and noodles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-aebc-700f-aa7e-e4e59507d32c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-aebc-700f-aa7e-e4e59507d32c",
        "storage_key": "property/6767906449167190/01a14137-aebc-700f-aa7e-e4e59507d32c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.doughzonedumplinghouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13633832395283633797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dough-zone-dumpling-house-overlake",
      "poi_latitude": "47.6311077",
      "poi_longitude": "-122.1449732",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-641-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0ZU1gdtkFQRhRYYEFQaNb0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_52e8489a-bab6-44da-a9a4-2784d923d1c2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Los Chilangos",
      "poi_type": "Restaurants",
      "poi_address": "14008 NE 8th St, Bellevue, WA 98007, USA",
      "poi_short_description": "Food truck & caterer offering Mexican street eats such as tacos, quesadillas & burritos.",
      "poi_long_description": "Food truck & caterer offering Mexican street eats such as tacos, quesadillas & burritos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-b422-735e-bb49-934a22585ff8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-b422-735e-bb49-934a22585ff8",
        "storage_key": "property/6767906449167190/01a14137-b422-735e-bb49-934a22585ff8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.loschilangos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12057285080896897425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-chilangos",
      "poi_latitude": "47.6174415",
      "poi_longitude": "-122.1531425",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-221-7623",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-aPkXRJtkFQRkQF6GuYUVKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_3bd9789e-275d-45e6-92ce-06913a27cf3e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Firenze",
      "poi_type": "Restaurants",
      "poi_address": "15600 NE 8th St O - 15, Bellevue, WA 98008, USA",
      "poi_short_description": "Candlelit restaurant with stucco walls & opera music offering Italian cuisine & a sizable wine list.",
      "poi_long_description": "Candlelit restaurant with stucco walls & opera music offering Italian cuisine & a sizable wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-b500-7307-af58-b1459fca10f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-b500-7307-af58-b1459fca10f9",
        "storage_key": "property/6767906449167190/01a14137-b500-7307-af58-b1459fca10f9.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://firenzerestaurantbellevue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14193453564766303354&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firenze",
      "poi_latitude": "47.62087100000001",
      "poi_longitude": "-122.13004259999998",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-957-1077",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa68-732b-b514-b67c464b1be5",
        "storage_key": "property/6767906449167190/019d021f-aa68-732b-b514-b67c464b1be5.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJt_QvLZoSkFQRerTlJ9FG-cQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_1b1e3875-64f6-4d71-8a19-93564b896fc3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Stop & Shop Kosher Grocery",
      "poi_type": "Shopping & Retail",
      "poi_address": "1313 156th Ave NE #100, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-b6cd-74fe-afd3-e04759366d5b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-b6cd-74fe-afd3-e04759366d5b",
        "storage_key": "property/6767906449167190/01a14137-b6cd-74fe-afd3-e04759366d5b.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6499403781857372040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stop--shop-kosher-grocery",
      "poi_latitude": "47.6217394",
      "poi_longitude": "-122.1330784",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 206-739-3725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ae98-7048-8e20-74c2d09f9ddf",
        "storage_key": "property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE77r_69tkFQRiGdw5U2FMlo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_0f00924f-f228-41a0-94f8-53aee78b429d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "653 156th Ave NE, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-bd82-73a9-802d-80c08cfc3ca9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-bd82-73a9-802d-80c08cfc3ca9",
        "storage_key": "property/6767906449167190/01a14137-bd82-73a9-802d-80c08cfc3ca9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/bellevue-wa-pharmacies/653-156th-ave-ne-bellevue-wa-98007/storeid=11690?WT.mc_id=LS_GOOGLE_RX_11690",
      "poi_directions_map_url": "https://maps.google.com/?cid=4881810390052798039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "47.6163007",
      "poi_longitude": "-122.1336059",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-641-9105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-adfe9a92c97b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-adfe9a92c97b",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-adfe9a92c97b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSz_OwBVtkFQRV37oT6-sv0M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_3bcd1c7e-d14f-4589-95c5-e8ea2f75a675",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "India Metro Hypermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "653 156th Ave NE, Bellevue, WA 98007, USA",
      "poi_short_description": "Spacious Indian grocery store offering a wide variety of staples, freshly made rotis, and sugarcane juice.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-b9f9-761e-9cf2-f693495ac1c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-b9f9-761e-9cf2-f693495ac1c2",
        "storage_key": "property/6767906449167190/01a14137-b9f9-761e-9cf2-f693495ac1c2.webp",
        "width": 1017,
        "height": 1280
      },
      "poi_business_url": "https://m.facebook.com/IndiaMetroHypermarket/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7300084721352458647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "india-metro-hypermarket",
      "poi_latitude": "47.6163007",
      "poi_longitude": "-122.133606",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-643-3992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ae98-7048-8e20-74c2d09f9ddf",
        "storage_key": "property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQFEYnJtkFQRl0F4ZmAcT2U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_fba7b2d2-9042-442f-850b-5e51622f08cc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "QFC",
      "poi_type": "Shopping & Retail",
      "poi_address": "15600 NE 8th St Ste K1, Bellevue, WA 98008, USA",
      "poi_short_description": "Supermarket chain selling typical groceries & produce, plus homeware & electronics.",
      "poi_long_description": "Supermarket chain selling typical groceries & produce, plus homeware & electronics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-b72c-76ac-8740-8f08b5d0fc8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-b72c-76ac-8740-8f08b5d0fc8e",
        "storage_key": "property/6767906449167190/01a14137-b72c-76ac-8740-8f08b5d0fc8e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.qfc.com/stores/grocery/wa/bellevue/crossroads/705/00826?cid=loc_70500826_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6005041107593243398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qfc",
      "poi_latitude": "47.620136200000005",
      "poi_longitude": "-122.1308521",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 425-865-0282",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ae98-7048-8e20-74c2d09f9ddf",
        "storage_key": "property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz_B3r7ptkFQRBqu2PxIxVlM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4c328cc3-7b63-4e54-af8b-f1a64d6aa0cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Grocery Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "15625 NE 8th St, Bellevue, WA 98008, USA",
      "poi_short_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_long_description": "Discount chain carrying brand-name groceries, plus items like gifts & toys (many sell beer & wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-bea2-7169-a46e-1ffbc361c738.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-bea2-7169-a46e-1ffbc361c738",
        "storage_key": "property/6767906449167190/01a14137-bea2-7169-a46e-1ffbc361c738.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.groceryoutlet.com/circulars/storeid/243",
      "poi_directions_map_url": "https://maps.google.com/?cid=2496154894601994707&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grocery-outlet",
      "poi_latitude": "47.6163824",
      "poi_longitude": "-122.1313737",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-633-1640",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ae98-7048-8e20-74c2d09f9ddf",
        "storage_key": "property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjXBe1bBtkFQR08EaxaYfpCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_14a3579c-1f3c-4e52-b59d-80ceaf1f878b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Fred Meyer",
      "poi_type": "Shopping & Retail",
      "poi_address": "2041 148th Ave NE, Bellevue, WA 98007, USA",
      "poi_short_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_long_description": "Longtime retail chain for groceries, apparel & furniture, plus toys, electronics, housewares & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-bad6-7290-8c22-064a51d05ca4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-bad6-7290-8c22-064a51d05ca4",
        "storage_key": "property/6767906449167190/01a14137-bad6-7290-8c22-064a51d05ca4.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.fredmeyer.com/stores/grocery/wa/bellevue/bellevue/701/00023?cid=loc_70100023_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14498903893239462462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fred-meyer",
      "poi_latitude": "47.629454",
      "poi_longitude": "-122.14447529999998",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 425-865-8560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ae98-7048-8e20-74c2d09f9ddf",
        "storage_key": "property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp7G-aqhtkFQRPvoQvUV0Nsk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e57dcdc2-e5bc-4e29-8366-48cf9d804f6d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "15563 NE 24th St, Bellevue, WA 98007, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-c1bf-71cd-ab61-bb5874559b08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-c1bf-71cd-ab61-bb5874559b08",
        "storage_key": "property/6767906449167190/01a14137-c1bf-71cd-ab61-bb5874559b08.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/wa/bellevue/131/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4366857472428041994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "47.6307602",
      "poi_longitude": "-122.1334288",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 425-641-5069",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-ae98-7048-8e20-74c2d09f9ddf",
        "storage_key": "property/6767906449167190/019d021f-ae98-7048-8e20-74c2d09f9ddf.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb0fDw6ZtkFQRCmfVDLwxmjw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_4f9867a1-8a1a-4502-9693-5252bca4067f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Michaels",
      "poi_type": "Shopping & Retail",
      "poi_address": "15600 NE 8th St Ste D-4, Bellevue, WA 98008, USA",
      "poi_short_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_long_description": "Chain retailer carrying art & hobby supplies plus home decor (most offer classes & custom framing).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-c3a9-77aa-aaa7-c10e3e734736.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-c3a9-77aa-aaa7-c10e3e734736",
        "storage_key": "property/6767906449167190/01a14137-c3a9-77aa-aaa7-c10e3e734736.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.michaels.com/WA/Bellevue/8403/?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=10721983067725175011&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "michaels",
      "poi_latitude": "47.6180701",
      "poi_longitude": "-122.1290215",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-747-1221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aea0-70cd-9551-2e0b691c9cb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aea0-70cd-9551-2e0b691c9cb8",
        "storage_key": "property/6767906449167190/019d021f-aea0-70cd-9551-2e0b691c9cb8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJz_B3r7ptkFQR4xiD58oizJQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_63b41522-e439-4b7f-a2eb-b3df9d5b0618",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "JOANN Fabric and Crafts",
      "poi_type": "Shopping & Retail",
      "poi_address": "15600 NE 8th St Ste H1, Bellevue, WA 98008, USA",
      "poi_short_description": "Chain providing a wide range of fabrics, plus sewing & arts & crafts supplies (most offer classes).",
      "poi_long_description": "Chain providing a wide range of fabrics, plus sewing & arts & crafts supplies (most offer classes).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-c3b8-70be-b0a2-b319472a3fbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-c3b8-70be-b0a2-b319472a3fbf",
        "storage_key": "property/6767906449167190/01a14137-c3b8-70be-b0a2-b319472a3fbf.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://stores.joann.com/wa/bellevue/2067/?utm_campaign=website-local-page&utm_medium=google&utm_content=website&utm_source=local-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=15435324230930461289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "joann-fabric-and-crafts",
      "poi_latitude": "47.6188869",
      "poi_longitude": "-122.1300422",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 425-644-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aea0-70cd-9551-2e0b691c9cb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aea0-70cd-9551-2e0b691c9cb8",
        "storage_key": "property/6767906449167190/019d021f-aea0-70cd-9551-2e0b691c9cb8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1XEdhLptkFQRafKWsZtJNdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_4ef88fbe-9b9a-4110-b0ab-66b00cbb6337",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Daiso - Japanese Household Goods",
      "poi_type": "Shopping & Retail",
      "poi_address": "15600 NE 8th St H2, Bellevue, WA 98008, USA",
      "poi_short_description": "Japanese variety-store chain featuring Japanese beauty products, housewares & snacks.",
      "poi_long_description": "Japanese variety-store chain featuring Japanese beauty products, housewares & snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-c6e7-76ce-bcf6-59cd5e931bb0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-c6e7-76ce-bcf6-59cd5e931bb0",
        "storage_key": "property/6767906449167190/01a14137-c6e7-76ce-bcf6-59cd5e931bb0.webp",
        "width": 1280,
        "height": 1030
      },
      "poi_business_url": "https://daisous.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5444228334712061166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daiso---japanese-household-goods",
      "poi_latitude": "47.619196599999995",
      "poi_longitude": "-122.1299977",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-643-8148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aea0-70cd-9551-2e0b691c9cb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aea0-70cd-9551-2e0b691c9cb8",
        "storage_key": "property/6767906449167190/019d021f-aea0-70cd-9551-2e0b691c9cb8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvwu_lrBtkFQR7vygXtPIjUs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_d4306116-2760-459f-81f6-d16f5cdeba83",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Stevenson Elementary School",
      "poi_type": "Education",
      "poi_address": "14220 NE 8th St, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-4c1e-712b-8207-76346454a126.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-4c1e-712b-8207-76346454a126",
        "storage_key": "property/6767906449167190/019d021f-4c1e-712b-8207-76346454a126.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stevenson.bsd405.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14660775940968094214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stevenson-elementary-school",
      "poi_latitude": "47.6178776",
      "poi_longitude": "-122.14974279999998",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 425-456-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJucCf71JskFQRBhr_zAqKdcs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_0a9f405d-e9b5-4785-b501-e3a722b616cf",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Odle Middle School",
      "poi_type": "Education",
      "poi_address": "502 143rd Ave NE, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-c6d0-72fb-b64b-6c5e9e0a7c02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-c6d0-72fb-b64b-6c5e9e0a7c02",
        "storage_key": "property/6767906449167190/01a14137-c6d0-72fb-b64b-6c5e9e0a7c02.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://odle.bsd405.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9832305570843940243&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "odle-middle-school",
      "poi_latitude": "47.6148842",
      "poi_longitude": "-122.1492154",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-456-6600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ35JNxI13CEERk1U_qdJdc4g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7e988751-249d-4f1f-a52f-512ece2478c8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Interlake High School",
      "poi_type": "Education",
      "poi_address": "16245 NE 24th St, Bellevue, WA 98008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-c922-7359-9bad-422e8ec48718.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-c922-7359-9bad-422e8ec48718",
        "storage_key": "property/6767906449167190/01a14137-c922-7359-9bad-422e8ec48718.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.bsd405.org/interlake",
      "poi_directions_map_url": "https://maps.google.com/?cid=17278387475018937795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "interlake-high-school",
      "poi_latitude": "47.6289368",
      "poi_longitude": "-122.1240449",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-456-7200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUSIRAaJtkFQRw_UPHN0pye8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_660fe99c-9459-4440-814b-b989d2bbe541",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Kelsey Creek Home School",
      "poi_type": "Education",
      "poi_address": "301 151st Pl NE, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.bsd405.org/jingmei",
      "poi_directions_map_url": "https://maps.google.com/?cid=1400319759337732786&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kelsey-creek-home-school",
      "poi_latitude": "47.6122616",
      "poi_longitude": "-122.13860160000002",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-456-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJj8FPKrVtkFQRsjpJ42bvbhM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_15972115-b74e-4d24-879b-b78434b7e5a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Lake Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "14310 SE 12th St, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-c683-7447-b666-7148b3e811df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-c683-7447-b666-7148b3e811df",
        "storage_key": "property/6767906449167190/01a14137-c683-7447-b666-7148b3e811df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://lakehills.bsd405.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7443643174643906241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-hills-elementary-school",
      "poi_latitude": "47.6009898",
      "poi_longitude": "-122.1492309",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 425-456-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJCVVKjDlskFQRwTZpewciTWc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_ecc0bc53-8fdf-4fb4-ac17-861ba29600dc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Highland Middle School",
      "poi_type": "Education",
      "poi_address": "15027 NE Bel Red Rd, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-ca60-744a-b6c1-4345bc6cb6be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-ca60-744a-b6c1-4345bc6cb6be",
        "storage_key": "property/6767906449167190/01a14137-ca60-744a-b6c1-4345bc6cb6be.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://highland.bsd405.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10989070628931970382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "highland-middle-school",
      "poi_latitude": "47.6256535",
      "poi_longitude": "-122.1407313",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 425-456-6400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJF8VGL6ZtkFQRTiUrsYMFgZg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d822c145-7811-4de6-937d-99b97bf8c6a9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Bellevue College",
      "poi_type": "Education",
      "poi_address": "3000 Landerholm Cir SE, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-5be5-725a-986d-113b685dfbe2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-5be5-725a-986d-113b685dfbe2",
        "storage_key": "property/6767906449167190/019d021f-5be5-725a-986d-113b685dfbe2.webp",
        "width": 1280,
        "height": 858
      },
      "poi_business_url": "https://www.bellevuecollege.edu/?utm_source=google&utm_medium=gmb&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13504348681346997872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellevue-college",
      "poi_latitude": "47.5840453",
      "poi_longitude": "-122.1482391",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 425-564-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZWLQKB5skFQRcN6zmpMVabs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8ff304cc-3c9d-41fa-be05-548e505b35dd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Birch Tree Academy Lake Hills - Preschool & Childcare",
      "poi_type": "Education",
      "poi_address": "655 156th Ave SE, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-5445-7318-89dc-a9ef418afc5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-5445-7318-89dc-a9ef418afc5a",
        "storage_key": "property/6767906449167190/019d021f-5445-7318-89dc-a9ef418afc5a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.birchtreeacademy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8049221198321830222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "birch-tree-academy-lake-hills---preschool--childcare",
      "poi_latitude": "47.6040394",
      "poi_longitude": "-122.1315157",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 425-264-8967",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw8A_RzNskFQRTkmEhAiUtG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_bd71cab1-69da-4286-8de9-c2b911a5ae52",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Early Learning Center",
      "poi_type": "Education",
      "poi_address": "Q Building, 3000 Landerholm Cir SE, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-cde9-768f-b091-b1d2890d2db1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-cde9-768f-b091-b1d2890d2db1",
        "storage_key": "property/6767906449167190/01a14137-cde9-768f-b091-b1d2890d2db1.webp",
        "width": 750,
        "height": 925
      },
      "poi_business_url": "https://www.bellevuecollege.edu/childcare/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4644958816853720387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "early-learning-center",
      "poi_latitude": "47.588459",
      "poi_longitude": "-122.1452331",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 425-564-2240",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl_jexiFskFQRQ33iEm81dkA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_d7c4bda2-ffc8-4a9b-8dd0-8592ebbc3158",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Bellevue Big Picture School",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4255 153rd Ave SE, Bellevue, WA 98006, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-cd11-752f-9177-4d7355b21b75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-cd11-752f-9177-4d7355b21b75",
        "storage_key": "property/6767906449167190/01a14137-cd11-752f-9177-4d7355b21b75.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "http://bellevuebigpicture.bsd405.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15536802518010673839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellevue-big-picture-school",
      "poi_latitude": "47.5698689",
      "poi_longitude": "-122.1374774",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-456-7800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIT7RqiZskFQRr7prl5LPndc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_8f1a5770-cfc7-48a6-b69c-0f8934645286",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Regal Crossroads - Bellevue",
      "poi_type": "Entertainment",
      "poi_address": "1200 156th Ave NE, Bellevue, WA 98008, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-cfcd-746e-b88a-945dede1f6d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-cfcd-746e-b88a-945dede1f6d9",
        "storage_key": "property/6767906449167190/01a14137-cfcd-746e-b88a-945dede1f6d9.webp",
        "width": 1280,
        "height": 822
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-crossroads-bellevue-0905?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=18169663382834449961&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-crossroads---bellevue",
      "poi_latitude": "47.621105",
      "poi_longitude": "-122.1287394",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b233-7335-8e49-dee6d95a23f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b233-7335-8e49-dee6d95a23f3",
        "storage_key": "property/6767906449167190/019d021f-b233-7335-8e49-dee6d95a23f3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJKYpt7rptkFQRKQ5FZpScJ_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_0adc40e5-b190-491b-9395-6c11187a5a0d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Crossroads Bellevue",
      "poi_type": "Shopping & Retail",
      "poi_address": "15600 NE 8th St, Bellevue, WA 98008, USA",
      "poi_short_description": "Indoor shopping complex with restaurants, a food court, live music, events & a multi-screen cinema.",
      "poi_long_description": "Indoor shopping complex with restaurants, a food court, live music, events & a multi-screen cinema.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-47cd-7048-97df-6b5684a54d64.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-47cd-7048-97df-6b5684a54d64",
        "storage_key": "property/6767906449167190/019d021f-47cd-7048-97df-6b5684a54d64.webp",
        "width": 1280,
        "height": 872
      },
      "poi_business_url": "http://www.crossroadsbellevue.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=15451357343200188664&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-bellevue",
      "poi_latitude": "47.6195007",
      "poi_longitude": "-122.1302973",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-644-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aea0-70cd-9551-2e0b691c9cb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aea0-70cd-9551-2e0b691c9cb8",
        "storage_key": "property/6767906449167190/019d021f-aea0-70cd-9551-2e0b691c9cb8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ13EdhLptkFQR-BgSi6M_btY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_afca2599-d291-4c0f-b4e9-561e807699d9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Edgeworks Climbing Bellevue",
      "poi_type": "Health and Wellness",
      "poi_address": "15600 NE 8th St c 1, Bellevue, WA 98008, USA",
      "poi_short_description": "Indoor rock-climbing gym featuring 45-ft walls, bouldering, fitness classes & a pro-shop.",
      "poi_long_description": "Indoor rock-climbing gym featuring 45-ft walls, bouldering, fitness classes & a pro-shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-d6db-70f8-87c9-4e399536b99a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-d6db-70f8-87c9-4e399536b99a",
        "storage_key": "property/6767906449167190/01a14137-d6db-70f8-87c9-4e399536b99a.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://edgeworksclimbing.com/bellevue/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10879954916312234295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edgeworks-climbing-bellevue",
      "poi_latitude": "47.619763299999995",
      "poi_longitude": "-122.1287669",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-644-2445",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ34yt0LBtkFQRNzkOF1pd_ZY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_5b7bbf5f-0a41-404e-8d39-433b27b06a98",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Cinemark Lincoln Square Cinemas and IMAX",
      "poi_type": "Entertainment",
      "poi_address": "700 Bellevue Way NE #310, Bellevue, WA 98004, USA",
      "poi_short_description": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks.",
      "poi_long_description": "Theater complex with multiple screens, all-stadium seating & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-d4ec-77bc-a40d-af6d1673d9b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-d4ec-77bc-a40d-af6d1673d9b6",
        "storage_key": "property/6767906449167190/01a14137-d4ec-77bc-a40d-af6d1673d9b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/wa-bellevue/cinemark-lincoln-square-cinemas-and-imax?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&y_source=1_MTc0OTI5MTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=7387621705008313531&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-lincoln-square-cinemas-and-imax",
      "poi_latitude": "47.6168325",
      "poi_longitude": "-122.2010429",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 425-450-9100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b233-7335-8e49-dee6d95a23f3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b233-7335-8e49-dee6d95a23f3",
        "storage_key": "property/6767906449167190/019d021f-b233-7335-8e49-dee6d95a23f3.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ6Ov_4VskFQRu3T8pcwahmY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_266828c2-74c2-4172-9aa3-14b742b2d65b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Lucky Strike Bellevue",
      "poi_type": "Entertainment",
      "poi_address": "700 Bellevue Way NE Ste 250, Bellevue, WA 98004, USA",
      "poi_short_description": "Upscale entertainment destination with bowling, craft food & cocktails, plus lively arcades.",
      "poi_long_description": "Upscale entertainment destination with bowling, craft food & cocktails, plus lively arcades.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-d36c-74ca-8c1a-4a5ed0fb47e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-d36c-74ca-8c1a-4a5ed0fb47e7",
        "storage_key": "property/6767906449167190/01a14137-d36c-74ca-8c1a-4a5ed0fb47e7.webp",
        "width": 930,
        "height": 328
      },
      "poi_business_url": "https://www.luckystrikeent.com/location/lucky-strike-bellevue?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=15423049631215897569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-strike-bellevue",
      "poi_latitude": "47.6169661",
      "poi_longitude": "-122.20134259999998",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 425-453-5137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkTtnrYhskFQR4cvXveytCdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_ab1eedb4-4102-4262-ae57-1bf3fb0de636",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "KidsQuest Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "1116 108th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "Interactive educational exhibits staged indoors & outdoors, plus workshops & summer camps.",
      "poi_long_description": "Interactive educational exhibits staged indoors & outdoors, plus workshops & summer camps.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14135-9139-7629-acbb-8ee5d77bf941.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-9139-7629-acbb-8ee5d77bf941",
        "storage_key": "property/6767906449167190/01a14135-9139-7629-acbb-8ee5d77bf941.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.kidsquestmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=565907723386877940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kidsquest-childrens-museum",
      "poi_latitude": "47.6208569",
      "poi_longitude": "-122.1959171",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-637-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b271-73aa-b720-8ce5d95f9e07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b271-73aa-b720-8ce5d95f9e07",
        "storage_key": "property/6767906449167190/019d021f-b271-73aa-b720-8ce5d95f9e07.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJc8TRNYxskFQR9PcffBOC2gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_1ac34717-c340-4025-9280-f32716a67d7b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Meydenbauer Center",
      "poi_type": "Entertainment",
      "poi_address": "11100 NE 6th St, Bellevue, WA 98004, USA",
      "poi_short_description": "Large convention center with meeting & event space, plus a theater featuring cultural performances.",
      "poi_long_description": "Large convention center with meeting & event space, plus a theater featuring cultural performances.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-d5ac-7753-8f80-85d397e3831c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-d5ac-7753-8f80-85d397e3831c",
        "storage_key": "property/6767906449167190/01a14137-d5ac-7753-8f80-85d397e3831c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.meydenbauer.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3893778936351170745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meydenbauer-center",
      "poi_latitude": "47.61572",
      "poi_longitude": "-122.1912436",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 425-637-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14138-34f8-7629-847b-7ef7155e4fa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-34f8-7629-847b-7ef7155e4fa0",
        "storage_key": "property/6767906449167190/01a14138-34f8-7629-847b-7ef7155e4fa0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2z4DiolskFQRuSAc_097CTY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convention_center"
    },
    {
      "id": "custom_166d0bba-2bdb-4fd0-a95c-648b909bbe60",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Bellevue Downtown Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "10201 NE 4th St, Bellevue, WA 98004, USA",
      "poi_short_description": "Lushly planted city park featuring a 240-foot-wide waterfall, a picnic green & a playground.",
      "poi_long_description": "Lushly planted city park featuring a 240-foot-wide waterfall, a picnic green & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14135-ad68-7752-bef4-bc8e09ffbe94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-ad68-7752-bef4-bc8e09ffbe94",
        "storage_key": "property/6767906449167190/01a14135-ad68-7752-bef4-bc8e09ffbe94.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://parks.bellevuewa.gov/parks-and-trails/parks/bellevue-downtown-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4725159899354261845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellevue-downtown-park",
      "poi_latitude": "47.6126836",
      "poi_longitude": "-122.2041686",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 425-452-6885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b2d4-77ed-90af-98cbafaef8ed",
        "storage_key": "property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVqRI4dskFQRVWnuu-Qjk0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_1fee3c39-1af1-4365-b721-81364e98ba0e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Bellevue Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "575 Bellevue Square, Bellevue, WA 98004, USA",
      "poi_short_description": "Sprawling venue that includes retail shops, casual & upscale dining options & a comedy club.",
      "poi_long_description": "Sprawling venue that includes retail shops, casual & upscale dining options & a comedy club.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14135-7e6c-77d0-8090-5e5ee7d2645a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-7e6c-77d0-8090-5e5ee7d2645a",
        "storage_key": "property/6767906449167190/01a14135-7e6c-77d0-8090-5e5ee7d2645a.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://bellevuecollection.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15740512561876323718&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellevue-square",
      "poi_latitude": "47.6157647",
      "poi_longitude": "-122.203721",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 425-454-8096",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aea0-70cd-9551-2e0b691c9cb8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aea0-70cd-9551-2e0b691c9cb8",
        "storage_key": "property/6767906449167190/019d021f-aea0-70cd-9551-2e0b691c9cb8.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF7Wdd4ZskFQRhk02OceIcdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_1acd1ade-9d3e-4ad5-89be-26d2b3ab6d7f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Meydenbauer Bay Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "419 98th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "This 2.5-acre beach offers in-season swimming plus a fishing dock & play/picnic areas.",
      "poi_long_description": "This 2.5-acre beach offers in-season swimming plus a fishing dock & play/picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-db9d-7033-9d80-6c6db9ee3a68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-db9d-7033-9d80-6c6db9ee3a68",
        "storage_key": "property/6767906449167190/01a14137-db9d-7033-9d80-6c6db9ee3a68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bellevuewa.gov/city-government/departments/parks/parks-and-trails/parks/meydenbauer-beach-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15139820113588723733&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meydenbauer-bay-park",
      "poi_latitude": "47.6124346",
      "poi_longitude": "-122.211107",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 425-452-6885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b2d4-77ed-90af-98cbafaef8ed",
        "storage_key": "property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1ysjdIFskFQRFSDF2S1yG9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_04cac0d3-4778-4adc-af9a-4ae82093b6e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Overlake Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1035 116th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-7033-76dd-9c17-a707a90cc7e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-7033-76dd-9c17-a707a90cc7e5",
        "storage_key": "property/6767906449167190/019d021f-7033-76dd-9c17-a707a90cc7e5.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.overlakehospital.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14792161275466343213&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overlake-medical-center",
      "poi_latitude": "47.6208526",
      "poi_longitude": "-122.1869157",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 425-688-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl9mHnO1skFQRLeN1zE5QSM0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_0637038d-6304-459b-a0cf-71933a5bd2cb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "MultiCare Indigo Urgent Care - Bellevue",
      "poi_type": "Health and Wellness",
      "poi_address": "15600 NE 8th St Ste A-4, Bellevue, WA 98008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-7179-71e5-95ca-09368a4799be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-7179-71e5-95ca-09368a4799be",
        "storage_key": "property/6767906449167190/019d021f-7179-71e5-95ca-09368a4799be.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.indigohealth.com/locations/urgent-care-bellevue/?utm_source=pg-google&utm_medium=organic&utm_campaign=pg-listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=10599936177723415466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "multicare-indigo-urgent-care---bellevue",
      "poi_latitude": "47.6173694",
      "poi_longitude": "-122.1313927",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-643-3331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQeeA0LBtkFQRqhsE88qJGpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_eeb5b6c9-5e60-4119-a0f7-490c58022757",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "15585 NE 24th St, Bellevue, WA 98007, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-de00-74cc-bc28-fa2e0669c573.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-de00-74cc-bc28-fa2e0669c573",
        "storage_key": "property/6767906449167190/01a14137-de00-74cc-bc28-fa2e0669c573.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-15585+ne+24th+st-bellevue-wa-98007/id=10553",
      "poi_directions_map_url": "https://maps.google.com/?cid=902153759480533891&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "47.6308012",
      "poi_longitude": "-122.13288929999996",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 425-643-8281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-adfe9a92c97b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-adfe9a92c97b",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-adfe9a92c97b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVUVw6BtkFQRg9OefhAYhQw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_ac9a25e8-00f1-4a8c-bad4-dcd64c86413e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "15053 Main St, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14135-9785-73ed-944c-bfab0ba736c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-9785-73ed-944c-bfab0ba736c1",
        "storage_key": "property/6767906449167190/01a14135-9785-73ed-944c-bfab0ba736c1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=685&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=6895371275183819772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "47.6092802",
      "poi_longitude": "-122.1393555",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-698-2575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuVdKhUpskFQR_IvDO6RHsV8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d9f56d9c-5372-47aa-b704-c5b32765285f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "15600 NE 8th St, Bellevue, WA 98008, USA",
      "poi_short_description": "Affordable fitness center offering well-maintained equipment and a clean, welcoming environment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-72c7-70a8-a723-ff79a16cc28f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-72c7-70a8-a723-ff79a16cc28f",
        "storage_key": "property/6767906449167190/019d021f-72c7-70a8-a723-ff79a16cc28f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/bellevue-crossroads-wa?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=762238429309884620&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "47.619989399999994",
      "poi_longitude": "-122.1286925",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-502-7826",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUW9mb3BtkFQRzNgqHdADlAo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_468df3e3-df38-4b55-88ac-bceafff454b5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Bellevue Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "14230 NE Bel Red Rd, Bellevue, WA 98007, USA",
      "poi_short_description": "Community-focused gym featuring a swimming pool, fitness equipment, and various group classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14135-9d58-724d-8c48-e2376cbbe91c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-9d58-724d-8c48-e2376cbbe91c",
        "storage_key": "property/6767906449167190/01a14135-9d58-724d-8c48-e2376cbbe91c.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.seattleymca.org/locations/bellevue-family-ymca?y_source=1_MTAzMDUwMTk4Mi03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=3596679688337147818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellevue-family-ymca",
      "poi_latitude": "47.626047199999995",
      "poi_longitude": "-122.1496649",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 425-746-9900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrb6ZIT9pkFQRqscy2h756TE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2cb1d5b6-ce78-41fa-90e1-4ff0fae612f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "CorePower Yoga - Bellevue",
      "poi_type": "Health and Wellness",
      "poi_address": "10307 NE 10th St, Bellevue, WA 98004, USA",
      "poi_short_description": "Yoga studio featuring heated workouts and a variety of fitness classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14135-a9d2-778b-a847-39d531e33688.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-a9d2-778b-a847-39d531e33688",
        "storage_key": "property/6767906449167190/01a14135-a9d2-778b-a847-39d531e33688.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.corepoweryoga.com/yoga-studios/wa/seattle/bellevue",
      "poi_directions_map_url": "https://maps.google.com/?cid=3784995085780942064&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corepower-yoga---bellevue",
      "poi_latitude": "47.6190952",
      "poi_longitude": "-122.2027677",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 833-448-2561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-af2f-73e3-8d27-20d81bac7725",
        "storage_key": "property/6767906449167190/019d021f-af2f-73e3-8d27-20d81bac7725.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJT6mUoY9skFQR8HySDPoAhzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_e8115dfe-bf58-48d5-a0b1-f0314ea0cc7b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "30 Bellevue Way NE, Bellevue, WA 98004, USA",
      "poi_short_description": "Energetic gym featuring coach-led, heart rate-based group workouts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-7c01-7068-8b89-d456826df661.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-7c01-7068-8b89-d456826df661",
        "storage_key": "property/6767906449167190/019d021f-7c01-7068-8b89-d456826df661.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/bellevue-washington-0578?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=12956525170247266492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "47.6107875",
      "poi_longitude": "-122.20118589999998",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 206-785-9190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY7WJjn1skFQRvPD-5_7SzrM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_dd3f57be-0871-4e97-9a48-adeb3787d06c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Bellevue Club",
      "poi_type": "Health and Wellness",
      "poi_address": "11200 SE 6th St, Bellevue, WA 98004, USA",
      "poi_short_description": "Exclusive athletic and social club featuring wellness facilities and on-site dining.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-7850-76c9-9ac3-342a8db00c94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-7850-76c9-9ac3-342a8db00c94",
        "storage_key": "property/6767906449167190/019d021f-7850-76c9-9ac3-342a8db00c94.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.bellevueclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13879219116737045652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellevue-club",
      "poi_latitude": "47.6049955",
      "poi_longitude": "-122.18952639999998",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 425-455-1616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14138-34f8-7629-847b-7ef7155e4fa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-34f8-7629-847b-7ef7155e4fa0",
        "storage_key": "property/6767906449167190/01a14138-34f8-7629-847b-7ef7155e4fa0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJtToSvHpskFQRlCTsXEDknMA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_18f97d90-2b67-4767-a0f5-b12268b391d8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Crossroads Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "999 164th Ave NE, Bellevue, WA 98008, USA",
      "poi_short_description": "Family-friendly park featuring a popular spray park and playground, plus walking trails and sports courts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-e4a0-73dc-81d2-25784fc701e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-e4a0-73dc-81d2-25784fc701e7",
        "storage_key": "property/6767906449167190/01a14137-e4a0-73dc-81d2-25784fc701e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bellevuewa.gov/city-government/departments/parks/parks-and-trails/parks/crossroads-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=1330023217463793667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-park",
      "poi_latitude": "47.6175803",
      "poi_longitude": "-122.1235667",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 425-452-6914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b2d4-77ed-90af-98cbafaef8ed",
        "storage_key": "property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUjYbbltkFQRA5jzyxExdRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a6089d61-8b1e-420f-b473-06f241fbaa4e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Phantom Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2064-2098 156th Ave SE, Bellevue, WA 98007, USA",
      "poi_short_description": "Serene neighborhood park featuring walking trails and scenic lake views.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-7ebe-774e-aae5-f3a836b4a7e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-7ebe-774e-aae5-f3a836b4a7e2",
        "storage_key": "property/6767906449167190/019d021f-7ebe-774e-aae5-f3a836b4a7e2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://bellevuewa.gov/city-government/departments/parks/parks-and-trails/parks/phantom-lake-loop",
      "poi_directions_map_url": "https://maps.google.com/?cid=8067380810251337219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phantom-lake-park",
      "poi_latitude": "47.5922004",
      "poi_longitude": "-122.1303306",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-452-7225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b2d4-77ed-90af-98cbafaef8ed",
        "storage_key": "property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJlVKhiihskFQRA37VphoY9W8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6b23c5d8-09c7-448e-bcff-0cdb71d37375",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Bellevue Park Ranger Station",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15416 SE 16th St, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-e559-7554-b7f1-f8d4e0570630.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-e559-7554-b7f1-f8d4e0570630",
        "storage_key": "property/6767906449167190/01a14137-e559-7554-b7f1-f8d4e0570630.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1133072776087464701&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellevue-park-ranger-station",
      "poi_latitude": "47.5966137",
      "poi_longitude": "-122.13412389999998",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-452-7225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b2d4-77ed-90af-98cbafaef8ed",
        "storage_key": "property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf8amBC9skFQR_epbw697uQ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_26e396bd-5da4-44be-95b4-4c28abb890f9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Bellevue Demonstration Garden -- King County Master Gardeners",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15500 SE 16th St, Bellevue, WA 98007, USA",
      "poi_short_description": "Free public garden featuring flower and vegetable demonstrations as well as trails for wandering.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-e49f-75dd-85e8-e56b9c8b5dc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-e49f-75dd-85e8-e56b9c8b5dc4",
        "storage_key": "property/6767906449167190/01a14137-e49f-75dd-85e8-e56b9c8b5dc4.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://kingcounty.mastergardenerfoundation.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3656993231649415637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellevue-demonstration-garden----king-county-master-gardeners",
      "poi_latitude": "47.5963783",
      "poi_longitude": "-122.132959",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14135-cc00-7552-a3e8-810914c8d41d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14135-cc00-7552-a3e8-810914c8d41d",
        "storage_key": "property/6767906449167190/01a14135-cc00-7552-a3e8-810914c8d41d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJZoX5S5skFQR1aF49vc_wDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_69c98150-7d3c-42e7-8942-895bc6c6cfcc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Lake Hills Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1200 164th Ave SE, Bellevue, WA 98008, USA",
      "poi_short_description": "Spacious neighborhood park featuring diverse playgrounds, sports facilities, and scenic walking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-ea27-77be-82d7-f93177e66899.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-ea27-77be-82d7-f93177e66899",
        "storage_key": "property/6767906449167190/01a14137-ea27-77be-82d7-f93177e66899.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bellevuewa.gov/city-government/departments/parks/parks-and-trails/parks/lake-hills-community-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10249420453731996637&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lake-hills-community-park",
      "poi_latitude": "47.5986035",
      "poi_longitude": "-122.12217869999998",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 425-452-6914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b2d4-77ed-90af-98cbafaef8ed",
        "storage_key": "property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJax2TS9NtkFQR3ZNRUplBPY4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f20930f5-6af2-44d8-a5c6-8a673f15c3db",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Robinswood Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2432 148th Ave SE, Bellevue, WA 98007, USA",
      "poi_short_description": "Home to historic Robinswood House, this community park features a pond, tennis center & dog corral.",
      "poi_long_description": "Home to historic Robinswood House, this community park features a pond, tennis center & dog corral.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-eb98-72ea-8995-73b4005166cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-eb98-72ea-8995-73b4005166cf",
        "storage_key": "property/6767906449167190/01a14137-eb98-72ea-8995-73b4005166cf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bellevuewa.gov/city-government/departments/parks/parks-and-trails/parks/robinswood-community-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8129947132166737434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robinswood-community-park",
      "poi_latitude": "47.5874385",
      "poi_longitude": "-122.141092",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 425-452-6914",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b2d4-77ed-90af-98cbafaef8ed",
        "storage_key": "property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0VcJwCBskFQRGg6Bp9df03A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d6278bff-5777-4826-9f3e-4c725ae7eba8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Kelsey Creek Farm",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "410 130th Pl SE, Bellevue, WA 98005, USA",
      "poi_short_description": "Meadows & forests mark this 150-acre park featuring trails & 2 historic barns with farm animals.",
      "poi_long_description": "Meadows & forests mark this 150-acre park featuring trails & 2 historic barns with farm animals.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-ed74-7088-a610-a51e9fa2e564.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-ed74-7088-a610-a51e9fa2e564",
        "storage_key": "property/6767906449167190/01a14137-ed74-7088-a610-a51e9fa2e564.webp",
        "width": 1280,
        "height": 942
      },
      "poi_business_url": "https://parks.bellevuewa.gov/community-centers/kelsey-creek-farm",
      "poi_directions_map_url": "https://maps.google.com/?cid=17856122545105251794&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kelsey-creek-farm",
      "poi_latitude": "47.6038072",
      "poi_longitude": "-122.1638997",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-452-7688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b607-71bb-8bad-447653e0889a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b607-71bb-8bad-447653e0889a",
        "storage_key": "property/6767906449167190/019d021f-b607-71bb-8bad-447653e0889a.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJxd_aIkJskFQR0q3XVtmwzfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "farm"
    },
    {
      "id": "custom_88cec15d-1b0f-4f05-9c1c-40a1d42529a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Lattawood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4530 155th Ave SE, Bellevue, WA 98006, USA",
      "poi_short_description": "Peaceful neighborhood park featuring a well-maintained playground, open green spaces, and walking trails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-ecd3-7423-a3f4-feebdedcfad1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-ecd3-7423-a3f4-feebdedcfad1",
        "storage_key": "property/6767906449167190/01a14137-ecd3-7423-a3f4-feebdedcfad1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://parks.bellevuewa.gov/parks-and-trails/parks/lattawood-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=18019480425394361806&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lattawood-park",
      "poi_latitude": "47.5639714",
      "poi_longitude": "-122.1338322",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 425-452-6885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b2d4-77ed-90af-98cbafaef8ed",
        "storage_key": "property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcaBPu8dukFQRzlW8wPkNEvo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_af5c0bee-d147-4a1c-945b-a91d813eb9ea",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Weowna Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1420 168th Ave SE, Bellevue, WA 98008, USA",
      "poi_short_description": "Old growth forest area offering lake views & a 2.5 mile trail along a creek with waterfalls & pools.",
      "poi_long_description": "Old growth forest area offering lake views & a 2.5 mile trail along a creek with waterfalls & pools.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-f4b1-737e-931a-410582aafd6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-f4b1-737e-931a-410582aafd6b",
        "storage_key": "property/6767906449167190/01a14137-f4b1-737e-931a-410582aafd6b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://bellevuewa.gov/city-government/departments/parks/parks-and-trails/parks/weowna-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=14702070153134951177&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "weowna-park",
      "poi_latitude": "47.5935608",
      "poi_longitude": "-122.1156248",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 425-452-6885",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b2d4-77ed-90af-98cbafaef8ed",
        "storage_key": "property/6767906449167190/019d021f-b2d4-77ed-90af-98cbafaef8ed.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJj-dmUdFtkFQRCUt7zOg-CMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bbb6fbfd-d7ed-475f-a839-0fae818b166d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Overlake Park Presbyterian Church, Bellevue",
      "poi_type": "Transportation & Transit",
      "poi_address": "1836 156th Ave NE, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-f5b4-7340-8505-dfd306681ace.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-f5b4-7340-8505-dfd306681ace",
        "storage_key": "property/6767906449167190/01a14137-f5b4-7340-8505-dfd306681ace.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://bellevuechurch.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17855963720068169816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overlake-park-presbyterian-church-bellevue",
      "poi_latitude": "47.6270335",
      "poi_longitude": "-122.1310553",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 425-746-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14138-3567-76ea-b911-589456446232.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-3567-76ea-b911-589456446232",
        "storage_key": "property/6767906449167190/01a14138-3567-76ea-b911-589456446232.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJfzRiEKRtkFQRWADtAGYgzfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_7562bdeb-7919-40f5-a987-127e300f89a1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Eastgate Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "14200 SE 32nd St, Bellevue, WA 98007, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-f554-7595-8a7a-df17572f58dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-f554-7595-8a7a-df17572f58dd",
        "storage_key": "property/6767906449167190/01a14137-f554-7595-8a7a-df17572f58dd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/parking/east-king-county/eastgate-park-ride",
      "poi_directions_map_url": "https://maps.google.com/?cid=18015168638889034985&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eastgate-park--ride",
      "poi_latitude": "47.581240099999995",
      "poi_longitude": "-122.1529256",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 206-296-0100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b6ec-7159-973c-a7882cf45bc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b6ec-7159-973c-a7882cf45bc6",
        "storage_key": "property/6767906449167190/019d021f-b6ec-7159-973c-a7882cf45bc6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJjbQkCKdukFQR6QS9uW28Avo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_85f34c65-5750-49b1-aa04-fe8ca90984b8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Overlake Village",
      "poi_type": "Transportation & Transit",
      "poi_address": "Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14135-bf0d-7338-a787-e36f33f64632.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-bf0d-7338-a787-e36f33f64632",
        "storage_key": "property/6767906449167190/01a14135-bf0d-7338-a787-e36f33f64632.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10615758405200537383&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overlake-village",
      "poi_latitude": "47.636309999999995",
      "poi_longitude": "-122.13891999999998",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14135-cc8d-758d-840f-b90cc7292532.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14135-cc8d-758d-840f-b90cc7292532",
        "storage_key": "property/6767906449167190/01a14135-cc8d-758d-840f-b90cc7292532.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1v7dQxtkFQRJ2dYWwbAUpM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "custom_5d0817de-b316-4d2a-bb90-ee2f0bdc25cd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Redmond Technology Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "15590 NE 36th St, Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-f93b-71ab-85b5-ae4d67944728.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-f93b-71ab-85b5-ae4d67944728",
        "storage_key": "property/6767906449167190/01a14137-f93b-71ab-85b5-ae4d67944728.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.soundtransit.org/ride-with-us/stops-stations/redmond-technology-station?route_tab=more_info",
      "poi_directions_map_url": "https://maps.google.com/?cid=15446890542952244159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "redmond-technology-station",
      "poi_latitude": "47.64443",
      "poi_longitude": "-122.1333075",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 888-889-6368",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b6ec-7159-973c-a7882cf45bc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b6ec-7159-973c-a7882cf45bc6",
        "storage_key": "property/6767906449167190/019d021f-b6ec-7159-973c-a7882cf45bc6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJXSjc4m1tkFQRv2MCkRthXtY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_91184f7a-b8cd-41ad-b6d6-6686bb22a411",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Bellevue Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "10850 NE 6th St, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-f8d1-7699-b951-e681b32a4dc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-f8d1-7699-b951-e681b32a4dc0",
        "storage_key": "property/6767906449167190/01a14137-f8d1-7699-b951-e681b32a4dc0.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://kingcounty.gov/depts/transportation/metro/schedules-maps/maps/boarding/bellevue-tc.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=5545940749640766301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellevue-transit-center",
      "poi_latitude": "47.6156053",
      "poi_longitude": "-122.1964378",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-688-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14138-34fc-769d-b93e-61a6ec7aae34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a14138-34fc-769d-b93e-61a6ec7aae34",
        "storage_key": "property/6767906449167190/01a14138-34fc-769d-b93e-61a6ec7aae34.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJzwQslolskFQRXZOzZ7oj90w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_65a3bca1-b8ee-44a6-a763-4ec65d90ba5a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "South Bellevue Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "2700 Bellevue Way SE, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-ffe8-7149-aa76-67dbc65664b2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-ffe8-7149-aa76-67dbc65664b2",
        "storage_key": "property/6767906449167190/01a14137-ffe8-7149-aa76-67dbc65664b2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7305589421076838038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-bellevue-park-and-ride",
      "poi_latitude": "47.586458099999994",
      "poi_longitude": "-122.1897782",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 206-553-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b6ec-7159-973c-a7882cf45bc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b6ec-7159-973c-a7882cf45bc6",
        "storage_key": "property/6767906449167190/019d021f-b6ec-7159-973c-a7882cf45bc6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJT98SuvZrkFQRlvYiLt-qYmU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_3a45de1f-9f73-4eec-804c-70aa6667abc9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Seattle-Tacoma International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "17801 International Blvd, SeaTac, WA 98158, USA",
      "poi_short_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_long_description": "Large hub serving the Pacific Northwest & featuring live music plus rail service to Seattle.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-99a9-74ce-9b26-85971def8b3c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d021f-99a9-74ce-9b26-85971def8b3c",
        "storage_key": "property/6767906449167190/019d021f-99a9-74ce-9b26-85971def8b3c.webp",
        "width": 1200,
        "height": 798
      },
      "poi_business_url": "https://www.portseattle.org/sea-tac",
      "poi_directions_map_url": "https://maps.google.com/?cid=11084442547078838199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "seattle-tacoma-international-airport",
      "poi_latitude": "47.4483652",
      "poi_longitude": "-122.3085927",
      "poi_miles_from_property": "19.4",
      "poi_walking_minutes": "7 hours 18 mins",
      "poi_biking_minutes": "1 hour 59 mins",
      "poi_driving_minutes": "29 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b706-74ba-91b1-575d7f31f6cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b706-74ba-91b1-575d7f31f6cf",
        "storage_key": "property/6767906449167190/019d021f-b706-74ba-91b1-575d7f31f6cf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_f7qQlVDkFQRtzfcx8TZ05k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_2ff7c6bb-a9f5-40fc-9119-3647887b144f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Puget Sound Energy",
      "poi_type": "Major Employers & Offices",
      "poi_address": "355 110th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-fe51-74fe-9c47-ea44281c33be.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-fe51-74fe-9c47-ea44281c33be",
        "storage_key": "property/6767906449167190/01a14137-fe51-74fe-9c47-ea44281c33be.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://pse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15848797065919727439&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "puget-sound-energy",
      "poi_latitude": "47.6131089",
      "poi_longitude": "-122.1941862",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 888-225-5773",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzAJg2JskFQRTwdm__U88ts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_9f8f2b33-5b2d-4edd-88f8-9a050b1ab98a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "PACCAR Corporate Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "777 106th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-ffee-741a-ba92-110a85481dd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-ffee-741a-ba92-110a85481dd0",
        "storage_key": "property/6767906449167190/01a14137-ffee-741a-ba92-110a85481dd0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.paccar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9415904096697984547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paccar-corporate-offices",
      "poi_latitude": "47.616667",
      "poi_longitude": "-122.1995404",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-468-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbQdryIhskFQRIybUauMCrII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1bff26b8-d1c7-4dfc-9177-5547b289f57e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Symetra Financial Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "777 108th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "Financial consultant offering appointments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14137-fea7-776b-9ebc-d7de70ffab0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14137-fea7-776b-9ebc-d7de70ffab0f",
        "storage_key": "property/6767906449167190/01a14137-fea7-776b-9ebc-d7de70ffab0f.webp",
        "width": 842,
        "height": 1280
      },
      "poi_business_url": "https://www.symetra.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4874657410015519159&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "symetra-financial-center",
      "poi_latitude": "47.616596099999995",
      "poi_longitude": "-122.1965194",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-256-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-b6ec-7159-973c-a7882cf45bc6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-b6ec-7159-973c-a7882cf45bc6",
        "storage_key": "property/6767906449167190/019d021f-b6ec-7159-973c-a7882cf45bc6.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJU9EYI4lskFQRt2GzXRZDpkM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_63a3f16d-21b5-453b-8dfc-7f1350683335",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "SAP Concur",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Key Center, 601 108th Ave NE Unit 1000, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14138-036b-7108-9b66-932e0c778abf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-036b-7108-9b66-932e0c778abf",
        "storage_key": "property/6767906449167190/01a14138-036b-7108-9b66-932e0c778abf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.concur.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8288219684312941725&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sap-concur",
      "poi_latitude": "47.6161371",
      "poi_longitude": "-122.19681039999998",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-401-8412",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCQJC_IhskFQRnYTf1-OrBXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_73ca5551-f63d-4d0b-b079-2a5687b94785",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Valve",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10400 NE 4th St Fl 14, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14138-03d2-7691-acd3-168b863c849c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-03d2-7691-acd3-168b863c849c",
        "storage_key": "property/6767906449167190/01a14138-03d2-7691-acd3-168b863c849c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.valvesoftware.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17384773039538747108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valve",
      "poi_latitude": "47.614114",
      "poi_longitude": "-122.2008979",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 425-889-9642",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ZfoNIZskFQR5LZ-kvgeQ_E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_b7c78eba-9911-486a-86a7-82d2361af2ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Bungie, Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "550 106th Ave NE Ste 108, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14138-0a7a-70ea-bdb7-f3981ec7166a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-0a7a-70ea-bdb7-f3981ec7166a",
        "storage_key": "property/6767906449167190/01a14138-0a7a-70ea-bdb7-f3981ec7166a.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "http://www.bungie.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1361783880504146272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bungie-inc",
      "poi_latitude": "47.6153808",
      "poi_longitude": "-122.1986484",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 425-440-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz7LpiohskFQRYHlNajkH5hI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_15c94150-9296-4364-99f2-9c7939e609b1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Summit III",
      "poi_type": "Major Employers & Offices",
      "poi_address": "320 108th Ave NE, Bellevue, WA 98004, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14138-1489-7311-8a8f-a34764e1010f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-1489-7311-8a8f-a34764e1010f",
        "storage_key": "property/6767906449167190/01a14138-1489-7311-8a8f-a34764e1010f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hines.com/news/hines-summit-iii-design-released",
      "poi_directions_map_url": "https://maps.google.com/?cid=13322468846337035364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "summit-iii",
      "poi_latitude": "47.613395999999995",
      "poi_longitude": "-122.1958506",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk-22wfJtkFQRZIwgjdTq4rg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_eacdd6f3-4233-4d7e-9bbf-ae877b95f203",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "T-Mobile Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3625 132nd Ave SE, Bellevue, WA 98006, USA",
      "poi_short_description": "Wireless provider offering cell phones, data plans, Internet devices & accessories.",
      "poi_long_description": "Wireless provider offering cell phones, data plans, Internet devices & accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14135-c27e-73fb-a80e-69d462d27a0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14135-c27e-73fb-a80e-69d462d27a0a",
        "storage_key": "property/6767906449167190/01a14135-c27e-73fb-a80e-69d462d27a0a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13157546119071260821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-corporate-office",
      "poi_latitude": "47.578626199999995",
      "poi_longitude": "-122.1654623",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 855-977-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY06QCapukFQRleAPz3v-mLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e5997252-0a2a-4e32-a3c7-891c76d45898",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "poi_name": "Microsoft Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Microsoft Way, Redmond, WA 98052, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a14138-0a6c-7698-898f-e9a6c27a26b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a14138-0a6c-7698-898f-e9a6c27a26b6",
        "storage_key": "property/6767906449167190/01a14138-0a6c-7698-898f-e9a6c27a26b6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.microsoft.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=118546500136700318&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "microsoft-headquarters",
      "poi_latitude": "47.6458093",
      "poi_longitude": "-122.1319698",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-642-7676",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d021f-aa84-7601-9c83-b02c3806c0d2",
        "storage_key": "property/6767906449167190/019d021f-aa84-7601-9c83-b02c3806c0d2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGxUEuHFtkFQRnokD7mkppQE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    }
  ],
  "office_hours": [
    {
      "id": "ec_f93b1971271e41b01fda78a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_6a2cd50f066d017d7d4fff31",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_99d97b437817c083b0aad0a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_8deb315215b59ec021171b27",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_c40bc008bbeb661184cf4a46",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_e3dc711a-dc77-45e0-b637-558134f8d968",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "rating": "5.0",
      "name": "MK",
      "text": "Jay and Kim are an extraordinary team and it is very enjoyable touring and talking to them. Unfortunately the colonial does not meet my needs however it is extremely rare to tour an apartment and feel connected to the people that are there.\nJay and Kim I wish you all the best. Thank you for giving me all the information that I needed regarding the Colonial community.",
      "date": "2025-10-30",
      "title": ""
    },
    {
      "id": "custom_ab9383ba-e209-4327-9f77-55b9b183c473",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "rating": "5.0",
      "name": "Du Wenbo",
      "text": "The service attitude is very good, and the apartment environment is very good, clean and quiet. I like it very much.",
      "date": "2025-11-04",
      "title": ""
    },
    {
      "id": "custom_2e47d389-d592-4f94-8165-970ab5f7c18e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "rating": "5.0",
      "name": "Kevin Green",
      "text": "The application process was quite smooth. Jordan did a wonderful job explaining everything and processing the application for me.The compound is very beautiful and quiet as well.",
      "date": "2025-08-12",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_0a6a0789-19df-422d-99d9-714d317b60eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/019d0220-ac80-7794-942d-15272641e8b8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Empty bedroom with large window overlooking trees and brick building.",
        "public_id": "019d0220-ac80-7794-942d-15272641e8b8",
        "storage_key": "property/6767906449167190/019d0220-ac80-7794-942d-15272641e8b8.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1x1 Remodeled",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vD6nKkEeKh9&back=1"
    },
    {
      "id": "custom_e19e0807-5bd9-4a0d-8231-3be46557020b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167190/01a1a424-9c6d-710c-8eb7-e7bdf2aeae95.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a1a424-9c6d-710c-8eb7-e7bdf2aeae95",
        "storage_key": "property/6767906449167190/01a1a424-9c6d-710c-8eb7-e7bdf2aeae95.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1x1 Classic",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=EZv1TmTXgK5&back=1"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_a8ed5412e301237ac6d9bb24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "b66edd4cf30a0f31",
      "name": "NSF Tenant Fee",
      "description": "NSF Tenant Fee",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "nsff",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7511686431eb4d944261c2be",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "87ecfd24797f03d4",
      "name": "Late Fee",
      "description": "Late Fee",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d1b35830d943d74549106d81",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "08333707b4d1bbfd",
      "name": "2nd Late Fee",
      "description": "2nd Late Fee",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "$5 per day up to 20 days",
      "amount_type": "text",
      "timing": "Per Lease",
      "category": "Lease",
      "charge_code": "late",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_8d2c6e524756e49898f3b97e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "775d5b715d7880ac",
      "name": "Early Termination Fee",
      "description": "Early Termination Fee",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "percentage",
      "timing": "Per Lease",
      "category": "Term",
      "charge_code": "term",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_127fcafdb4e2eb6f6fc9bd24",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "5cbb523e0f30673c",
      "name": "Transfer Fee",
      "description": "Fee to transfer apartments",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per Lease",
      "category": "Transfer",
      "charge_code": "tran",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7027e104f10e06e88d1351f3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "7df4d013117cb177",
      "name": "Water Charge",
      "description": "Water Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on square footage and occupancy",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubwater",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_77d671373dec7b53d9b1cb66",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "52754ec531f0db4e",
      "name": "Sewer Charge",
      "description": "Sewer Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Based on square footage and occupancy",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_18978f1d116739bc7b4217b7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "3739d8257125b796",
      "name": "Garbage Charge",
      "description": "Garbage Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubtrash",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_67a386ad239dbf47bfa4ff2d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "fd132f56d49bc82b",
      "name": "Pest Control",
      "description": "Pest Control Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "pest",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_04c0432bf1fa9e0b2894cc1a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "214e539225b7de62",
      "name": "Storm Water Charge",
      "description": "Storm Water Utility Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubsewer",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_10b5fd54c63765a56f950289",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "7aba17d1c375f702",
      "name": "Common Area Electric",
      "description": "Common Area Electric Charge",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Equally divided, paid monthly.",
      "amount_type": "text",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "elec",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_d47d39c50d1897392c9a0591",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "cac461adce307f20",
      "name": "Utility Billing Admin Fee",
      "description": "Utility Admin Fee",
      "amount": 3.95,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Recurring",
      "category": "Utility",
      "charge_code": "ubadmin",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [
    {
      "id": "ec_ad247eaf0c5059d85e665555",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "2290392",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 200,
      "monthly_rent": 45,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_f7f7691094711ca7da66e602",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "yardi",
      "external_id": "2290391",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 300,
      "fee": 200,
      "monthly_rent": 45,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a19d29-daae-7540-bbf5-ef6fceaaa685",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Colonial Square Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "apartments-with-indoor-pool-bellevue-wa",
      "search_query": "apartments with indoor pool in Bellevue WA",
      "category": "Amenity",
      "h1_title": "Apartments with Indoor Pool in Bellevue, WA",
      "h2_subtitle": "Explore Colonial Square, offering comfort and convenience. While we don't have an indoor pool, our amenities enhance your living experience in Bellevue, WA.",
      "page_copy": "Welcome to Colonial Square, where sophistication meets comfort in the vibrant Crossroads neighborhood of Bellevue, WA. Although we don't feature an indoor pool, our community provides an array of exceptional amenities designed to enrich your living experience. Enjoy an active lifestyle with our on-site badminton court and mingle with neighbors in our well-equipped barbecue and grill area.\n\nOur prime location in Bellevue ensures you're never far from the city's attractions and conveniences. At Colonial Square, you'll benefit from our dedicated on-site management and maintenance teams, ensuring a seamless living experience. Come visit our community in Crossroads, Bellevue, WA, and see why Colonial Square is the perfect place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Indoor Pool in Bellevue, WA",
      "seo_description": "Discover Colonial Square in Bellevue, WA. While lacking an indoor pool, enjoy vibrant amenities in our welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-king-county",
      "search_query": "fitness center apartments King County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in King County",
      "h2_subtitle": "Colonial Square caters to active lifestyles in King County. While we lack a fitness center, our amenities offer plenty for health enthusiasts.",
      "page_copy": "Situated in the lively Crossroads neighborhood of Bellevue, WA, Colonial Square is perfect for those seeking an active lifestyle in King County. Although we don't feature a fitness center, our community offers numerous amenities that cater to your wellbeing. Enjoy access to our badminton court—a wonderful way to stay active and engaged.\n\nAt Colonial Square, residents can also unwind and connect with neighbors in our barbecue and grill area. Our on-site management and maintenance teams are always available to ensure your comfort and needs are met. Located in bustling Bellevue, this community offers easy access to local attractions and conveniences. Discover why Colonial Square makes for an ideal home in King County, merging comfort and an active lifestyle seamlessly.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in King County",
      "seo_description": "Experience active living at Colonial Square, King County. While there's no fitness center, enjoy dynamic amenities in Bellevue, WA.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-crossroads-bellevue",
      "search_query": "smoke free apartments near Crossroads Bellevue",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments Near Crossroads",
      "h2_subtitle": "Colonial Square offers a healthy lifestyle near Crossroads. Enjoy our smoke-free environment and vibrant amenities in Bellevue.",
      "page_copy": "Discover the charm of Colonial Square, a community that embodies comfort and a smoke-free lifestyle in the bustling Crossroads area of Bellevue, WA. Our commitment to providing a healthy living environment is matched by our carefully curated amenities that enhance your experience. Get active on our on-site badminton court or enjoy a leisurely community gathering in our barbecue and grill area.\n\nNestled in King County, Colonial Square ensures a high standard of living with on-site management and maintenance ready to address your needs. The vibrant culture of Crossroads is at your doorstep, offering residents convenient access to shopping, dining, and entertainment. Come experience a smoke-free, welcoming community at Colonial Square, where a healthy and engaging lifestyle awaits.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments Near Crossroads",
      "seo_description": "Colonial Square offers smoke-free living near Crossroads, Bellevue. Discover our welcoming community with vibrant amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "apartments-stainless-steel-appliances-bellevue",
      "search_query": "apartments with stainless steel appliances Bellevue",
      "category": "Amenity",
      "h1_title": "Apartments with Stainless Steel Appliances",
      "h2_subtitle": "Colonial Square offers modern living in Bellevue, WA. Our apartments feature thoughtfully designed spaces, accompanied by great amenities.",
      "page_copy": "Experience contemporary living at Colonial Square, a charming community located in the Crossroads area of Bellevue, WA. While our apartments are tailored to offer comfort and style, they do not currently include stainless steel appliances. However, our community boasts a suite of amenities that elevate your living experience.\n\nResidents can enjoy a variety of activities, such as engaging in an exciting game at the on-site badminton court or hosting social gatherings at our barbecue and grill area. Our dedicated on-site management and maintenance teams ensure that your needs are met promptly and efficiently. Nestled in the vibrant Crossroads neighborhood, Colonial Square offers easy access to shopping, dining, and entertainment in Bellevue, making it an ideal place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Stainless Steel Appliances",
      "seo_description": "Colonial Square, Bellevue, offers modern amenities and comfortable living near Crossroads, without stainless steel appliances.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "ample-parking-apartments-king-county",
      "search_query": "ample parking apartments King County",
      "category": "Amenity",
      "h1_title": "Ample Parking Apartments in King County",
      "h2_subtitle": "Colonial Square offers ample parking in the heart of King County. Our Bellevue community ensures convenience and comfort.",
      "page_copy": "Welcome to Colonial Square, a thriving community situated in the Crossroads neighborhood of Bellevue, WA, designed with the convenience of ample parking for all residents. Whether returning from a long day out in King County or preparing for a quick getaway, parking is never a worry at Colonial Square.\n\nOur community is equipped with amenities that cater to an active and engaging lifestyle. From a competitive round of badminton on our court to serene afternoons at our barbecue and grill area, Colonial Square offers more than just a place to live. Plus, our on-site management and maintenance teams are dedicated to providing exceptional service, ensuring that your home experience in Bellevue is seamless. Experience the ease and comfort of living with ample parking at Colonial Square, a welcoming apartment community in the heart of King County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Ample Parking Apartments in King County",
      "seo_description": "Enjoy ample parking and comfort at Colonial Square in King County. Located in Bellevue's Crossroads neighborhood with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "studio-apartments-bellevue-wa",
      "search_query": "studio apartments in Bellevue WA",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Bellevue, WA",
      "h2_subtitle": "Explore the studio apartments at Colonial Square in Bellevue, WA. Enjoy the vibrant Crossroads neighborhood and our exciting amenities.",
      "page_copy": "Discover the perfect studio apartment for you at Colonial Square, located in the heart of Bellevue, WA. While our community doesn't currently offer studio layouts, we do provide spacious and comfortable living options that cater to a variety of lifestyles. Situated in the lively Crossroads neighborhood, our residents enjoy quick access to local shopping, dining, and entertainment.\n\nColonial Square is packed with amenities designed to elevate your living experience. From an invigorating match at our badminton court to relaxing by the barbecue and grill area, there's something for everyone here. Our committed on-site management and maintenance teams are always available to ensure your living experience is hassle-free. Make Colonial Square your next home and enjoy all the benefits of living in Bellevue, a thriving city in King County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Bellevue, WA",
      "seo_description": "Check out Colonial Square for your next apartment in Bellevue, WA. Offering great amenities in the vibrant Crossroads area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-crossroads-bellevue",
      "search_query": "one bedroom apartments near Crossroads Bellevue",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments Near Crossroads",
      "h2_subtitle": "Colonial Square features one-bedroom apartments near Crossroads in Bellevue. Enjoy a vibrant community and top-notch amenities.",
      "page_copy": "Colonial Square presents an exceptional living experience with our one-bedroom apartments, perfect for those seeking comfort and style near Crossroads in Bellevue. Our community is ideally situated, offering unparalleled access to the dynamic Crossroads neighborhood, renowned for its eclectic mix of shopping, dining, and entertainment options.\n\nAt Colonial Square, residents benefit from a host of on-site amenities that enhance daily life. Enjoy a spirited game of badminton or unwind with friends at our inviting barbecue and grill area. With attentive on-site management and maintenance teams, your living experience is designed to be worry-free. Choose Colonial Square for your next home and immerse yourself in a welcoming community that prioritizes convenience and comfort in the heart of Bellevue, WA.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Near Crossroads",
      "seo_description": "Colonial Square offers one-bedroom apartments near Crossroads, Bellevue. Enjoy great amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "apartments-near-bellevue-college-wa",
      "search_query": "apartments near bellevue college wa",
      "category": "School",
      "h1_title": "Apartments Near Bellevue College, WA",
      "h2_subtitle": "Explore Colonial Square, conveniently located near Bellevue College, WA. Enjoy easy access to education and a lively local community.",
      "page_copy": "Colonial Square is your go-to choice for living close to Bellevue College, WA, offering a convenient location that makes commuting to classes a breeze. Located in the vibrant Crossroads neighborhood of Bellevue, our community provides more than just proximity to education—it offers a dynamic lifestyle enriched by a variety of dining, shopping, and recreation options.\n\nOur community stands out with outstanding amenities, including an exciting badminton court and a welcoming barbecue/grill area for social gatherings. Additionally, with on-site management and maintenance services, Colonial Square ensures a hassle-free living experience. Join a community that combines academic convenience with the comfort of home, right here in Bellevue, King County's bustling educational hub.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bellevue College, WA",
      "seo_description": "Find ideal living at Colonial Square, near Bellevue College, WA. Enjoy convenience, amenities, and a vibrant Crossroads neighborhood lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "apartments-close-lake-washington-tech-king-county",
      "search_query": "apartments close to lake washington institute of technology king county",
      "category": "School",
      "h1_title": "Apartments Close to Lake Washington Tech",
      "h2_subtitle": "Discover Colonial Square, ideally situated near Lake Washington Institute of Technology. Enjoy convenient access and a vibrant Crossroads community.",
      "page_copy": "Colonial Square offers a prime location for students and professionals seeking apartments close to Lake Washington Institute of Technology in King County. Our community provides easy access to the institute, making your daily commute quick and stress-free. Nestled in the spirited Crossroads neighborhood of Bellevue, we provide a perfect balance between educational pursuits and an engaging local atmosphere.\n\nDesigned with convenience in mind, Colonial Square boasts amenities such as a badminton court and a barbecue/grill area, perfect for relaxation and socializing. Our dedicated on-site management and maintenance teams ensure that residents enjoy a seamless living experience. Choose Colonial Square as your home and benefit from the ideal mix of proximity to education and an active community lifestyle in vibrant King County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Lake Washington Tech",
      "seo_description": "Live at Colonial Square, near Lake Washington Tech in King County. Enjoy easy access, vibrant community living, and top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "apartments-near-marymoor-park-redmond",
      "search_query": "apartments near Marymoor Park Redmond",
      "category": "Park",
      "h1_title": "Apartments Near Marymoor Park, Redmond",
      "h2_subtitle": "Experience Colonial Square, conveniently located near Marymoor Park in Redmond. Enjoy outdoor activities and a welcoming community.",
      "page_copy": "Choose Colonial Square for your next home and enjoy the benefits of living near Marymoor Park in Redmond. Our apartments provide an ideal base for those who love the outdoors, offering quick and easy access to one of the area's most beloved recreation spots. Whether you're an avid cyclist, runner, or just love a leisurely walk, Marymoor Park offers a myriad of activities just minutes from your doorstep.\n\nColonial Square ensures a balanced lifestyle with amenities like a refreshing barbecue/grill area and an exciting badminton court. Our dedicated on-site maintenance and management teams are committed to making your living experience as smooth as possible. Embrace a vibrant community lifestyle at Colonial Square and enjoy the best of what King County has to offer, with the beauty and recreation of Marymoor Park right nearby.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Marymoor Park, Redmond",
      "seo_description": "Live at Colonial Square near Marymoor Park, Redmond. Enjoy proximity to outdoor recreation and a vibrant, amenity-rich community in King County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "bellevue-botanical-garden-nearby-apartments-98007",
      "search_query": "Bellevue Botanical Garden nearby apartments 98007",
      "category": "Park",
      "h1_title": "Nearby Apartments to Bellevue Botanical Garden",
      "h2_subtitle": "Discover Colonial Square, positioned close to Bellevue Botanical Garden. Enjoy a blend of nature and modern living in the heart of Bellevue, 98007.",
      "page_copy": "At Colonial Square, you'll find the perfect retreat near the beautiful Bellevue Botanical Garden. Our apartments in the 98007 ZIP code offer a unique combination of tranquil natural settings and convenient accessibility. Living here places you minutes away from stunning floral displays and serene walking paths, making it an ideal choice for nature lovers and those seeking a peaceful environment.\n\nOur community at Colonial Square provides a host of amenities such as an exciting badminton court and designated barbecue/grill area, enhancing both relaxation and recreation options. Along with reliable on-site management and maintenance services, we ensure a smooth living experience. Embrace the charm of Bellevue, surrounded by nature's beauty, while enjoying the comforts and convenience of modern apartment living at Colonial Square.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Bellevue Botanical Garden, 98007",
      "seo_description": "Find tranquility at Colonial Square, near Bellevue Botanical Garden. Enjoy nature and modern living in 98007 with top amenities and services.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "apartments-close-lake-sammamish-state-park-king-county",
      "search_query": "apartments close to Lake Sammamish State Park King County",
      "category": "Park",
      "h1_title": "Apartments Near Lake Sammamish State Park",
      "h2_subtitle": "Explore Colonial Square, ideally located near Lake Sammamish State Park. Enjoy easy access to outdoor activities in King County.",
      "page_copy": "Colonial Square is the ideal choice for those seeking apartments close to Lake Sammamish State Park in King County. Our community offers excellent access to the park, perfect for families and outdoor enthusiasts alike. Whether you're into kayaking, hiking, or simply enjoying a picnic by the waterfront, Lake Sammamish State Park provides a host of activities just a short drive away.\n\nAt Colonial Square, you'll benefit from a range of amenities designed to enhance your living experience, including a lively badminton court and a communal barbecue/grill area. With our on-site management and maintenance teams, residents can expect a hassle-free lifestyle. Enjoy the beauty and recreational opportunities of Lake Sammamish State Park while relishing the comforts of home at Colonial Square, right in the heart of King County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lake Sammamish State Park",
      "seo_description": "Live at Colonial Square near Lake Sammamish State Park. Experience easy access to outdoor fun and modern amenities in the heart of King County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "grass-lawn-park-adjacent-apartments-bellevue",
      "search_query": "Grass Lawn Park adjacent apartments Bellevue",
      "category": "Park",
      "h1_title": "Apartments by Grass Lawn Park, Bellevue",
      "h2_subtitle": "Discover Colonial Square, adjacent to Grass Lawn Park in Bellevue. Enjoy a vibrant community with easy park access.",
      "page_copy": "Colonial Square offers an exceptional living experience with its prime location adjacent to Grass Lawn Park in Bellevue. If you're looking for a peaceful, green environment with the convenience of city living, our apartments are the perfect fit. Residents can enjoy leisurely walks and recreational activities at Grass Lawn Park, just steps from their front door.\n\nOur community is designed to offer more than just a place to live; we provide amenities like a dynamic barbecue/grill area and a dedicated badminton court for resident enjoyment. With dependable on-site management and maintenance services, you can indulge in a worry-free lifestyle. At Colonial Square, you're not just renting an apartment; you're joining a community that values the great outdoors and modern comfort, right next to Grass Lawn Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Grass Lawn Park, Bellevue",
      "seo_description": "Live at Colonial Square next to Grass Lawn Park in Bellevue. Enjoy a thriving community with direct access to park amenities and outdoor activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "apartments-near-bellevue-downtown",
      "search_query": "apartments near Bellevue Downtown",
      "category": "Transit",
      "h1_title": "Apartments Near Bellevue Downtown",
      "h2_subtitle": "Explore Colonial Square, conveniently located near Downtown Bellevue. Enjoy a dynamic lifestyle with the comforts of home just minutes away.",
      "page_copy": "Colonial Square offers the perfect apartment lifestyle near Bellevue Downtown, offering you the vibrant city life without compromising on comfort. Our community is situated close enough to downtown to enjoy easy access to a plethora of shopping, dining, and entertainment options. Whether you're working downtown or seeking leisure and excitement, you'll find everything you need right at your fingertips.\n\nBeyond the prime location, Colonial Square provides top-notch amenities like a barbecue/grill area and a badminton court, making sure residents have plenty of recreational opportunities. Our on-site management team ensures that everything runs smoothly, providing you with a worry-free living experience. Choose Colonial Square and relish in the proximity to Bellevue Downtown while enjoying the peaceful residential comfort our community offers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Convenient Apartments Near Bellevue Downtown",
      "seo_description": "Live close to Bellevue Downtown at Colonial Square. Enjoy the convenience of city living with modern amenities just minutes from downtown activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "colonial-square-apartments-belred-transit",
      "search_query": "Colonial Square apartments by BelRed transit",
      "category": "Transit",
      "h1_title": "Colonial Square by BelRed Transit",
      "h2_subtitle": "Experience Colonial Square, seamlessly connected to BelRed transit. Enjoy easy commutes and modern amenities in a vibrant community.",
      "page_copy": "Colonial Square is ideally positioned for convenient access to the BelRed transit corridor, making it the perfect choice for residents who depend on efficient public transportation. Our community is just a short stroll from the transit options that connect you seamlessly to all Bellevue and greater King County have to offer, including shopping, dining, and entertainment.\n\nLiving at Colonial Square, you'll benefit from a suite of amenities designed to enhance your lifestyle, such as a bustling barbecue/grill area and a lively badminton court. Our responsive on-site management and maintenance teams ensure that you have the best apartment living experience possible. Enjoy the perks of urban living without the hustle and bustle when you choose Colonial Square, perfectly situated by the BelRed transit line.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Colonial Square by BelRed Transit",
      "seo_description": "Discover Colonial Square, conveniently located by BelRed transit. Enjoy easy commutes and great amenities in a vibrant Bellevue community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "redmond-technology-nearby-apartment-rentals",
      "search_query": "Redmond Technology nearby apartment rentals",
      "category": "Transit",
      "h1_title": "Apartment Rentals Near Redmond Technology",
      "h2_subtitle": "Find your home at Colonial Square, close to Redmond Technology. Enjoy modern living with easy access to technology hubs.",
      "page_copy": "Situated just a short commute from Redmond Technology, Colonial Square offers ideal apartment rentals for those seeking proximity to Redmond's thriving tech scene. Our community is designed for those who value a quick and convenient commute to the tech hubs, providing easy access to key employers and innovation centers in the area.\n\nBeyond location, Colonial Square is a community that provides a range of quality amenities such as a barbecue/grill area and a badminton court, allowing residents to relax and socialize in their free time. We pride ourselves on excellent on-site management and reliable maintenance services, so you can focus on what truly matters. Discover the perfect blend of convenience and comfort at Colonial Square, where modern apartment living meets strategic location near Redmond Technology.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Rentals Near Redmond Technology",
      "seo_description": "Colonial Square offers rentals near Redmond Technology, blending convenience with modern amenities. Ideal for tech professionals seeking comfort and accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "apartments-close-to-spring-district-bellevue",
      "search_query": "apartments close to Spring District Bellevue",
      "category": "Transit",
      "h1_title": "Apartments Near Spring District Bellevue",
      "h2_subtitle": "Discover Colonial Square, close to Bellevue's Spring District. Enjoy a dynamic neighborhood with modern comforts just around the corner.",
      "page_copy": "Colonial Square provides an excellent living option for those seeking apartments close to the Spring District in Bellevue. Our location offers a perfect balance of being near a burgeoning tech and retail area while maintaining a tranquil residential atmosphere. You'll find yourself just minutes away from innovative startups and an array of dining options that make the Spring District a lively place to be.\n\nAt Colonial Square, you're not just close to the action; you can also enjoy a range of community amenities like a barbecue/grill area and a badminton court. With attentive on-site management and maintenance services, we ensure your living experience is as seamless as it is enjoyable. Choose Colonial Square to experience the convenience of living near the Spring District while enjoying the comforts of a welcoming home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Spring District Bellevue",
      "seo_description": "Live at Colonial Square, close to Bellevue's Spring District. Enjoy modern comforts and a vibrant neighborhood just minutes from retail and tech hubs.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "6767906449167190",
      "source": "generator",
      "page_item_url": "colonial-square-apartments-overlake-village-transit",
      "search_query": "Colonial Square by Overlake Village transit",
      "category": "Transit",
      "h1_title": "Colonial Square by Overlake Village Transit",
      "h2_subtitle": "Enjoy Colonial Square's proximity to Overlake Village transit. Experience seamless commuting in Bellevue with quality apartment living.",
      "page_copy": "Nestled near Overlake Village transit, Colonial Square provides the ideal apartment community for those looking to simplify their commute around Bellevue and beyond. Our strategic location ensures effortless access to public transportation while maintaining a peaceful residential environment. This makes it easy to reach shopping, dining, and entertainment options in the area.\n\nIn addition to having superb transit access, residents at Colonial Square enjoy amenities that include a badminton court and a barbecue/grill area for social gatherings. Our dedicated on-site management and maintenance teams are always available to assist our residents, providing a worry-free living experience. Choose Colonial Square to enjoy the perfect blend of transit convenience and comfortable living near Overlake Village.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Colonial Square by Overlake Village Transit",
      "seo_description": "Discover Colonial Square near Overlake Village transit. Enjoy easy commuting and quality amenities in a serene Bellevue community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "11309501310"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4252564046"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-K5JTX89J"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 8"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Comfy"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/e40ed47c-2ffe-4f82-a430-e67bd32d9fd5/app.js?property=e40ed47c-2ffe-4f82-a430-e67bd32d9fd5&propertyName=Colonial+Square&channelUuid=c248edae-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47709118887"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6InZWb1U5MzczVHBOa2RnN2dKcFF6QVE9PSIsInZhbHVlIjoic1pRRmNWK2Y4djlaZi9FVVZRcmplQT09IiwibWFjIjoiYzRmODgzZmVjODgyZGNjMTY4YzJkYTk2MzU5ODFlZTI4NzEyMjc2MjYyMTZkMjJjOGVlY2Y5OWE5Y2MwZDZlZiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "11309501310",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=4252564046",
  "custom_google_gtm_id": "GTM-K5JTX89J",
  "custom_rollout_phase": "Phase 8",
  "custom_vibesites_theme": "Comfy",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/e40ed47c-2ffe-4f82-a430-e67bd32d9fd5/app.js?property=e40ed47c-2ffe-4f82-a430-e67bd32d9fd5&propertyName=Colonial+Square&channelUuid=c248edae-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47709118887",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6InZWb1U5MzczVHBOa2RnN2dKcFF6QVE9PSIsInZhbHVlIjoic1pRRmNWK2Y4djlaZi9FVVZRcmplQT09IiwibWFjIjoiYzRmODgzZmVjODgyZGNjMTY4YzJkYTk2MzU5ODFlZTI4NzEyMjc2MjYyMTZkMjJjOGVlY2Y5OWE5Y2MwZDZlZiJ9",
  "custom_audioeye_site_id": "b01c47f3-7f85-4738-b0d0-592b4bab0149",
  "custom_audioeye_site_hash": "202ba3fa15fe5ed162742fa52d4664c9"
};

export const generatedAt = '2026-11-04T01:23:19.865Z';
